// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/varsome-icons.ttf?qo1493", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/varsome-icons.woff?qo1493", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/varsome-icons.svg?qo1493", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "#varsome-icons" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactModal__Overlay{
  opacity:0;
  background-color:rgba(0,0,0,.5) !important;
  z-index:10000;
  text-align:center
}

.ReactModal__Overlay--after-open{
  opacity:1;
  transition:opacity 300ms ease-out
}

.ReactModal__Content--after-open{
  transition:all 300ms ease-in
}

.ReactModal__Overlay--before-close{
  opacity:0
}

.ReactModal__Content--before-close{
  transition:all 300ms ease-in
}

.flag-form{
  padding:1rem 0 0 0;
  overflow-y:hidden;
  height:90%
}

.flag-form h4{
  padding:0 1.5rem
}

.flag-form .varsome-modal-content{
  padding:0 1.5rem 1.5rem 1.5rem;
  height:calc(100% - 95px);
  overflow-y:auto
}

.flag-form .varsome-modal-controls{
  padding:0 1.5rem 1rem 1.5rem;
  background-color:#fafafa;
  border-top:1px solid #999
}

.modal-container-window{
  background-color:#fff;
  box-shadow:0 25px 50px -12px rgba(0,0,0,.25);
  border-radius:4px
}

.modal--hubspot{
  padding:0 !important;
  width:initial !important;
  border-radius:7px !important;
  background-color:rgba(0,0,0,0) !important
}

.modal--simple{
  padding:2.5rem 1.5rem 2.5rem 1.5rem !important;
  text-align:center !important;
  width:35rem !important
}

.helper-text p{
  margin-bottom:0px !important;
  padding-top:4px !important
}

.tooltip-container{
  position:fixed;
  box-shadow:0px 10px 20px -6px rgba(0,0,0,.61)
}

.tooltip-content{
  letter-spacing:.025em;
  line-height:1.625
}

.tooltip-default .tooltip-content{
  --text-opacity:1;
  color:#1e293b;
  color:rgba(30, 41, 59, var(--text-opacity));
  padding-left:8px;
  padding-right:8px;
  padding-top:4px;
  padding-bottom:4px;
  max-width:384px;
  font-size:12px;
  line-height:16px;
  font-family:"Helvetica Neue",Helvetica,Arial,sans-serif
}

.tooltip-default .tooltip-content p{
  margin:0px;
  padding:0px
}

.tooltip-default .tooltip-path{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226, 232, 240, var(--text-opacity));
  stroke:currentColor;
  fill:#fff
}

.genome-browser-tooltip .tooltip-container{
  -webkit-backdrop-filter:blur(10px);
          backdrop-filter:blur(10px);
  box-shadow:0px 12px 24px -10px #000
}

.genome-browser-tooltip .tooltip-content{
  margin-left:16px;
  margin-right:16px;
  padding-top:8px;
  padding-bottom:8px;
  font-size:11px;
  line-height:14px;
  --text-opacity:1;
  color:#475569;
  color:rgba(71, 85, 105, var(--text-opacity))
}

.genome-browser-tooltip .tooltip-path{
  stroke:currentColor;
  --text-opacity:1;
  color:#cbd5e1;
  color:rgba(203, 213, 225, var(--text-opacity));
  fill:rgba(250,250,250,.87);
  stroke-width:1px
}

.genome-browser-tooltip .border-normal{
  --border-opacity:1;
  border-color:#94a3b8;
  border-color:rgba(148, 163, 184, var(--border-opacity));
  --border-opacity:0.4
}

.genome-browser-title .tooltip-container{
  -webkit-backdrop-filter:blur(10px);
          backdrop-filter:blur(10px);
  box-shadow:0px 12px 34px -10px rgba(0,0,7,.1)
}

.genome-browser-title .tooltip-content{
  padding-left:12px;
  padding-right:12px;
  padding-top:8px;
  padding-bottom:8px;
  font-size:11px;
  line-height:14px;
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241, 245, 249, var(--text-opacity))
}

.genome-browser-title .tooltip-path{
  stroke:currentColor;
  --text-opacity:1;
  color:#334155;
  color:rgba(51, 65, 85, var(--text-opacity));
  fill:rgba(38,48,66,.75);
  stroke-width:1px
}

.genome-browser-title a,.genome-browser-title .link{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241, 245, 249, var(--text-opacity))
}

.genome-browser-title .border-normal{
  --border-opacity:1;
  border-color:#94a3b8;
  border-color:rgba(148, 163, 184, var(--border-opacity));
  --border-opacity:0.4
}

.genome-browser-small-tooltip .tooltip-container{
  -webkit-backdrop-filter:blur(10px);
          backdrop-filter:blur(10px);
  box-shadow:0px 12px 34px -10px rgba(0,0,7,.1)
}

.genome-browser-small-tooltip .tooltip-content{
  padding-left:8px;
  padding-right:8px;
  padding-top:4px;
  padding-bottom:4px;
  font-size:11px;
  line-height:14px;
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241, 245, 249, var(--text-opacity))
}

.genome-browser-small-tooltip .tooltip-path{
  stroke:currentColor;
  --text-opacity:1;
  color:#334155;
  color:rgba(51, 65, 85, var(--text-opacity));
  fill:rgba(38,48,66,.75);
  stroke-width:1px
}

.genome-browser-small-tooltip a,.genome-browser-small-tooltip .link{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241, 245, 249, var(--text-opacity))
}

.publications-tooltip .tooltip-container{
  -webkit-backdrop-filter:blur(10px);
          backdrop-filter:blur(10px);
  box-shadow:0px 12px 24px -10px #000
}

.publications-tooltip .tooltip-content{
  margin-left:16px;
  margin-right:16px;
  padding-top:8px;
  padding-bottom:8px;
  font-size:11px;
  line-height:14px;
  --text-opacity:1;
  color:#475569;
  color:rgba(71, 85, 105, var(--text-opacity))
}

.publications-tooltip .tooltip-path{
  stroke:currentColor;
  --text-opacity:1;
  color:#cbd5e1;
  color:rgba(203, 213, 225, var(--text-opacity));
  fill:rgba(250,250,250,.75);
  stroke-width:1px
}

.publications-tooltip .border-normal{
  --border-opacity:1;
  border-color:#94a3b8;
  border-color:rgba(148, 163, 184, var(--border-opacity));
  --border-opacity:0.4
}

.tag-tooltip .tooltip-container{
  -webkit-backdrop-filter:blur(10px);
          backdrop-filter:blur(10px);
  box-shadow:0px 12px 24px -10px #000
}

.tag-tooltip .tooltip-content{
  margin-left:16px;
  margin-right:16px;
  padding-top:8px;
  padding-bottom:8px;
  font-size:12px;
  line-height:16px;
  --text-opacity:1;
  color:#475569;
  color:rgba(71, 85, 105, var(--text-opacity))
}

.tag-tooltip .tooltip-path{
  stroke:currentColor;
  --text-opacity:1;
  color:#cbd5e1;
  color:rgba(203, 213, 225, var(--text-opacity));
  fill:rgba(250,250,250,.87);
  stroke-width:1px
}

.tag-tooltip .border-normal{
  --border-opacity:1;
  border-color:#94a3b8;
  border-color:rgba(148, 163, 184, var(--border-opacity));
  --border-opacity:0.2
}

.plot-tooltip .tooltip-content{
  margin-left:16px;
  margin-right:16px;
  padding-top:8px;
  padding-bottom:8px;
  font-size:12px;
  line-height:16px;
  --text-opacity:1;
  color:#334155;
  color:rgba(51, 65, 85, var(--text-opacity))
}

.plot-tooltip .tooltip-path{
  stroke:currentColor;
  --text-opacity:1;
  color:#cbd5e1;
  color:rgba(203, 213, 225, var(--text-opacity));
  fill:#fff;
  stroke-width:1px
}

.plot-tooltip .border-normal{
  --border-opacity:1;
  border-color:#94a3b8;
  border-color:rgba(148, 163, 184, var(--border-opacity));
  --border-opacity:0.2
}

.tooltip-header{
  display:flex;
  align-items:center;
  padding-bottom:8px;
  margin-bottom:8px;
  border-bottom-width:1px;
  font-size:12px;
  line-height:16px
}

.tooltip-header .tooltip-title{
  font-weight:600;
  margin-right:16px;
  flex-grow:1
}

.tooltip-row{
  display:flex;
  padding-top:2px;
  padding-bottom:2px;
  font-size:12px;
  line-height:16px
}

.tooltip-row .tooltip-label{
  font-weight:600;
  margin-right:8px;
  flex-shrink:0
}

.font-awesome{
  font-family:"Font Awesome 5 Free","FontAwesome"
}

.grabbable{
  cursor:move;
  cursor:grab;
  cursor:-webkit-grab
}

.grabbable:active{
  cursor:grabbing;
  cursor:-webkit-grabbing
}

.text-red{
  color:#ab230f
}

.text-green{
  color:#3cdbc0
}

.font-helvetica{
  font-family:"Helvetica Neue",Helvetica,Arial,sans-serif
}

.font-raleway{
  font-family:"Raleway","Helvetica Neue",Helvetica,Arial,sans-serif
}

.table-p-10 td,.table-p-10 th{
  padding:10px
}

.table-b-light td,.table-b-light th{
  border:1px solid #eceeef
}

.no-stroke{
  stroke-width:0
}

.pseudo-class{
  margin-left:16px;
  margin-right:auto
}

.backdrop{
  background-color:rgba(180,180,180,.5)
}

.backdrop-blur{
  -webkit-backdrop-filter:blur(3px);
          backdrop-filter:blur(3px)
}

.backdrop-filter-blur{
  -webkit-backdrop-filter:blur(3px);
          backdrop-filter:blur(3px)
}

.backdrop-filter-blur-md{
  -webkit-backdrop-filter:blur(10px);
          backdrop-filter:blur(10px)
}

.shadow-inner-left{
  box-shadow:inset 7px 0px 15px -8px rgba(0,0,0,.1)
}

.max-h-screen-50px{
  max-height:calc(100vh - 50px)
}

.left--px{
  left:-1px
}

.no-border-last:last-child{
  border-color:rgba(0,0,0,0) !important
}

.show-parent-hover{
  opacity:0;
  visibility:hidden
}

*:hover>.show-parent-hover,*:focus-within>.show-parent-hover{
  visibility:visible;
  opacity:1 !important;
  transition:opacity 300ms linear
}

.show-parent-focus{
  opacity:0;
  visibility:hidden
}

*:focus-within>.show-parent-focus{
  visibility:visible;
  opacity:1 !important;
  transition:opacity 400ms linear
}

.transform-translate-x-100{
  transform:translateX(100%)
}

.transform-translate--y-50{
  transform:translateY(-50%)
}

.transition-linear{
  transition-timing-function:linear
}

.transition-top{
  transition:top .2s linear
}

.flex-basis-0{
  flex:1 1 0px
}

.font-roboto{
  font-family:"Roboto",sans-serif
}

.only-on-premium{
  display:none
}

.premiumUser .only-on-premium{
  display:block
}

.premiumUser .only-not-premium{
  display:none
}

.no-margin{
  margin:0px !important
}

.prevent-scroll{
  overflow:hidden
}

.text-larger-1{
  font-size:1.1em;
  line-height:1.1em
}

.text-larger-2{
  font-size:1.15em;
  line-height:1.15em
}

.text-larger-3{
  font-size:1.2em;
  line-height:1.2em
}

.text-larger-4{
  font-size:1.3em;
  line-height:1.3em
}

.text-smaller-1{
  font-size:.9em;
  line-height:.9em
}

.text-smaller-2{
  font-size:.8em;
  line-height:.8em
}

.text-smaller-3{
  font-size:.7em;
  line-height:.7em
}

@keyframes uil-ripple{
  0%{
    width:0;
    height:0;
    opacity:0;
    margin:0 0 0 0
  }

  33%{
    width:44%;
    height:44%;
    margin:-22% 0 0 -22%;
    opacity:1
  }

  100%{
    width:88%;
    height:88%;
    margin:-44% 0 0 -44%;
    opacity:0
  }
}

.varsome-loader{
  background:none;
  width:200px;
  height:200px;
  margin:0 auto
}

.varsome-loader.small-loader{
  width:100px;
  height:100px
}

.varsome-loader div{
  position:absolute;
  top:50%;
  left:50%;
  margin:0;
  width:0;
  height:0;
  opacity:0;
  border-radius:50%;
  border-width:16px;
  border-style:solid;
  animation:uil-ripple 2s ease-out infinite
}

.small-loader div{
  border-width:8px
}

.varsome-loader div:nth-of-type(1){
  border-color:#555
}

.varsome-loader div:nth-of-type(2){
  border-color:#3cdbc0;
  animation-delay:1s
}

@font-face{
  font-family:"varsome-icons";

  src:url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"),url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("svg");

  font-weight:normal;

  font-style:normal
}

i.varsome-icons{
  font-family:"varsome-icons" !important;
  speak:none;
  font-style:normal;
  font-weight:normal;
  font-variant:normal;
  text-transform:none;
  line-height:1;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale
}

.icon-fullscreen:before{
  content:""
}

.icon-star:before{
  content:""
}

.icon-star-o:before{
  content:""
}

.icon-chevron-right:before{
  content:""
}

.icon-chevron-left:before{
  content:""
}

.icon-chevron-down:before{
  content:""
}

.icon-chevron-up:before{
  content:""
}

.icon-search-minus:before{
  content:""
}

.icon-search-plus:before{
  content:""
}

.icon-close:before{
  content:""
}

.icon-question:before{
  content:""
}

.icon-info:before{
  content:""
}

.icon-cancel-circle:before{
  content:""
}

.icon-indent-increase:before{
  content:""
}

.icon-indent-decrease:before{
  content:""
}

.icon-arrow-right2:before{
  content:""
}

.icon-arrow-left2:before{
  content:""
}

.iconcaret-down:before{
  content:""
}

.iconcaret-up:before{
  content:""
}

.iconcaret-left:before{
  content:""
}

.iconcaret-right:before{
  content:""
}

.varsome-acmg-verdict{
  font-size:16px;
  font-weight:bold
}

.varsome-acmg-grid tr{
  border-top:1px solid #ccc !important;
  border-bottom:1px solid #ccc !important
}

.varsome-acmg-grid td{
  text-align:center;
  cursor:pointer;
  border-left:1px solid #ccc;
  border-right:1px solid #ccc
}

.varsome-acmg-grid td .rule-name{
  padding:.5rem
}

.varsome-acmg-grid td .rule-name:hover{
  background-color:#eaeaea
}

.varsome-acmg-grid td .rule-icon{
  cursor:pointer;
  padding:.5rem
}

.varsome-acmg-grid td .rule-icon i{
  color:#3cb4ff
}

.acmg-rules-table{
  padding-top:.6rem !important;
  padding-bottom:.1rem !important;
  padding-left:1px !important;
  padding-right:1px !important
}

@media(max-width: 1199px){
  .Dropdown-root{
    position:relative;
    margin-top:2px
  }

  .Dropdown-control{
    position:relative;
    overflow:hidden;
    background-color:#fff;
    border-radius:2px;
    box-sizing:border-box;
    color:#333;
    cursor:default;
    outline:none;
    padding:2px 0px 2px 0px;
    transition:all 200ms ease
  }

  .Dropdown-arrow{
    border-color:#999 rgba(0,0,0,0) rgba(0,0,0,0);
    border-style:solid;
    border-width:5px 5px 0;
    content:" ";
    display:inline-block;
    height:0;
    margin-top:-ceil(2.5);
    width:0
  }
}

@media(min-width: 1200px){
  .Dropdown-root{
    position:relative;
    margin-top:2px;
    display:inline-block;
    width:90%
  }

  .Dropdown-control{
    position:relative;
    overflow:hidden;
    background-color:#fff;
    border-radius:2px;
    box-sizing:border-box;
    color:#333;
    cursor:default;
    outline:none;
    padding:2px 25px 2px 3px;
    transition:all 200ms ease
  }

  .Dropdown-arrow{
    border-color:#999 rgba(0,0,0,0) rgba(0,0,0,0);
    border-style:solid;
    border-width:5px 5px 0;
    content:" ";
    display:block;
    height:0;
    margin-top:-ceil(2.5);
    position:absolute;
    right:16px;
    top:8px;
    width:0
  }
}

.Dropdown-control:hover{
  box-shadow:0 1px 0 rgba(0,0,0,.06)
}

.is-open .Dropdown-arrow{
  border-color:rgba(0,0,0,0) rgba(0,0,0,0) #999;
  border-width:0 5px 5px
}

.Dropdown-arrow-color{
  border-color:#fff rgba(0,0,0,0) rgba(0,0,0,0) !important
}

.Dropdown-arrow-color-disabled{
  border-color:#dcdcdc rgba(0,0,0,0) rgba(0,0,0,0) !important
}

.Dropdown-menu{
  border:1px solid #fff;
  box-sizing:border-box;
  margin-top:-1px;
  max-height:200px;
  overflow-y:auto;
  position:absolute;
  top:100%;
  width:100%;
  z-index:90;
  -webkit-overflow-scrolling:touch
}

.Dropdown-menu .Dropdown-group>.Dropdown-title{
  padding:8px 10px;
  color:#333;
  font-weight:bold;
  text-transform:capitalize
}

.Dropdown-option{
  box-sizing:border-box;
  color:rgba(51,51,51,.8);
  cursor:pointer;
  display:block;
  padding:8px 10px
}

.Dropdown-option:hover{
  background-color:#f2f9fc;
  color:#333
}

.Dropdown-option.is-selected{
  background-color:#f2f9fc;
  color:#333
}

.Dropdown-noresults{
  box-sizing:border-box;
  color:#ccc;
  cursor:default;
  display:block;
  padding:8px 10px
}

.Dropdown-placeholder-color-default-strength{
  font-size:1rem;
  color:#fff !important
}

.Dropdown-placeholder-color-custom-strength{
  font-size:1rem;
  color:#fff !important
}

.Dropdown-placeholder-color-rule-disabled{
  font-size:1rem;
  color:#dcdcdc !important
}

.Dropdown-backgroundColor{
  background-color:rgba(0,0,0,0) !important
}

.Dropdown-menu-color{
  background-color:#fff !important
}

.varsome-acmg-grid *{
  line-height:1 !important
}

.varsome-criteria-table .badge{
  font-weight:normal;
  padding:.7em .7em;
  border-radius:25px;
  width:100%;
  font-size:100%
}

.varsome-criteria-table .badge:hover{
  cursor:pointer
}

.stand-alone-color,.very-strong-color,.strong-color{
  color:#fff !important
}

.moderate-color,.supporting-color{
  color:#fff !important
}

.acmg-rule-colored-cell{
  padding-left:8px;
  padding-right:8px
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-stand-alone{
  background-color:#c70700;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-stand-alone .rule-name:hover{
  background-color:#fa0900
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-stand-alone .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#fa0900
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-very-strong{
  background-color:#c70700;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-very-strong .rule-name:hover{
  background-color:#fa0900
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-very-strong .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#fa0900
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-strong{
  background-color:#d93115;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-strong .rule-name:hover{
  background-color:#ec5036
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-strong .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#ec5036
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-moderate{
  background-color:#eb5b2b;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-moderate .rule-name:hover{
  background-color:#ef7f5a
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-moderate .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#ef7f5a
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-supporting{
  background-color:#fd8540;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-supporting .rule-name:hover{
  background-color:#fea572
}

.acmg-rule-colored-cell.rule-name-p.rule-strength-supporting .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#fea572
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-stand-alone{
  background-color:#076418;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-stand-alone .rule-name:hover{
  background-color:#0a9423
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-stand-alone .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#0a9423
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-very-strong{
  background-color:#076418;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-very-strong .rule-name:hover{
  background-color:#0a9423
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-very-strong .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#0a9423
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-strong{
  background-color:#258831;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-strong .rule-name:hover{
  background-color:#30b03f
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-strong .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#30b03f
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-moderate{
  background-color:#50a838;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-moderate .rule-name:hover{
  background-color:#68c44f
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-moderate .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#68c44f
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-supporting{
  background-color:#73c36f;
  color:#fff
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-supporting .rule-name:hover{
  background-color:#96d293
}

.acmg-rule-colored-cell.rule-name-b.rule-strength-supporting .acmg-strength-dropdown:hover{
  cursor:pointer;
  background-color:#96d293
}

.acmg-rule-colored-cell.rule-manually-disabled{
  background-color:#bbb
}

.varsome-axis-label{
  color:#373a3c
}

.varsome-rpkm-bar{
  fill:#577396
}

.varsome-rpkm-bar:hover{
  fill:#6989af
}

.varsome-rpkm-bar--highlight{
  fill:#ff6f23
}

.varsome-rpkm-bar--highlight:hover{
  fill:#fc8140
}

.varsome-het-bar{
  fill:#53a292
}

.varsome-het-bar:hover{
  opacity:.5
}

.varsome-hom-bar{
  fill:#7ac5b2
}

.varsome-hom-bar:hover{
  opacity:.8
}

.varsome-atlas-bar{
  fill:#2ca591
}

.varsome-atlas-bar:hover{
  opacity:.8
}

html{
  -ms-overflow-style:scrollbar;
  font-size:14px;
  -webkit-tap-highlight-color:rgba(0,0,0,0)
}

body{
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:1rem;
  line-height:1.5;
  color:#373a3c;
  background-color:#fff
}

button,input,select,textarea{
  margin:0;
  line-height:inherit;
  font:inherit;
  color:inherit
}

.gdpr-btn{
  display:inline-block;
  margin:0 .3em .3em 0;
  padding:.3em .3em;
  font-weight:600;
  font-size:1em;
  color:#007a86;
  border:1px solid #ddd;
  border-radius:.2em
}

button.gdpr-link{
  color:#818a91;
  text-align:center;
  background:none;
  border:none;
  padding:0 !important;
  font:inherit;
  cursor:pointer;
  width:100%
}

button.gdpr-link:hover{
  text-decoration:underline
}

button.gdpr-link:focus{
  outline:none
}

.gdpr-btn:focus{
  outline:none
}

.gdpr-modal:focus{
  outline:none
}

.gdpr-error-modal{
  font-family:Cabin,"Helvetica Neue",Helvetica,Arial,sans-serif;
  background-color:#fafafa;
  height:auto !important
}

.gdpr-request-error{
  width:100%;
  margin:10% 0;
  padding:1rem .5rem;
  background-color:#e69d9d;
  color:#fff;
  white-space:pre-line;
  text-align:center
}

.gdpr-modal{
  font-size:1.125rem;
  font-family:Cabin,"Helvetica Neue",Helvetica,Arial,sans-serif
}

@media all and (min-width: 768px)and (max-width: 1200px){
  .gdpr-modal{
    font-size:1rem
  }
}

@media all and (max-width: 767px){
  .gdpr-modal{
    font-size:.85em
  }
}

.gdpr-modal a:not([href]):not([tabindex]),.gdpr-modal a:not([href]):not([tabindex]):focus,.gdpr-modal a:not([href]):not([tabindex]):hover{
  color:#2ca591 !important;
  text-decoration:none !important
}

.gdpr-modal a:not([href]):hover{
  color:#1c695c !important;
  text-decoration:underline !important
}

.gdpr-modal .varsome-logo{
  max-width:25%
}

@media all and (min-width: 768px)and (max-width: 1024px){
  .gdpr-modal .varsome-logo{
    max-width:30%
  }
}

@media all and (max-width: 767px){
  .gdpr-modal .varsome-logo{
    max-width:40%
  }
}

@media all and (min-width: 768px)and (max-width: 1024px){
  .gdpr-modal .terms-checkbox{
    margin-left:2em
  }
}

@media all and (max-width: 767px){
  .gdpr-modal .terms-checkbox{
    margin-left:2em
  }
}

.gdpr-modal input[type=checkbox]{
  -webkit-appearance:none;
  -moz-appearance:none;
  vertical-align:middle;
  width:15px;
  height:15px;
  font-size:20px;
  border:1px solid #000
}

.gdpr-modal input[type=checkbox]:checked:after{
  position:relative;
  bottom:8px;
  left:-1px;
  content:"✓"
}

.gdpr-modal input[type=checkbox]~label{
  margin-top:-4px;
  margin-left:25px;
  display:inline-block
}

.gdpr-modal input:focus{
  outline:none
}

.gdpr-modal button:focus{
  outline:none
}

.gdpr-modal .action-btns{
  display:inline-block;
  width:25%;
  margin:0 .3em .3em 0;
  padding:.3em .3em;
  font-weight:600;
  font-size:1em;
  color:#fff;
  border:.16em solid rgba(255,255,255,0)
}

.gdpr-modal .btn-accept-submit{
  background-color:#217d6e;
  border-color:#217d6e
}

.gdpr-modal .btn-accept-submit:hover{
  border-color:#fff;
  border-radius:.2em
}

.gdpr-modal .btn-submit:disabled,.gdpr-modal .btn-submit[disabled]{
  border:1px solid #999;
  background-color:#fafafa;
  color:#999
}

.gdpr-modal .btn-submit:disabled:hover,.gdpr-modal .btn-submit[disabled]:hover{
  pointer-events:none
}

.gdpr-modal .btn-submit:enabled,.gdpr-modal .btn-submit[enabled]{
  color:#fff;
  border-color:#217d6e;
  background-color:#217d6e
}

.gdpr-modal .btn-submit:enabled:hover,.gdpr-modal .btn-submit[enabled]:hover{
  border-color:#fff;
  border-radius:.2em
}

.gdpr-modal .flex-box-2{
  display:flex;
  justify-content:flex-end
}

@media all and (max-width: 767px){
  .gdpr-modal .action-btns{
    display:block;
    margin-left:.2em auto;
    width:100%;
    font-size:.8em
  }
}

.gdpr-modal .error-box{
  color:#fff;
  text-align:center;
  margin-top:1rem;
  background-color:#e69d9d;
  padding:1rem .5rem
}

@media all and (max-width: 767px){
  .gdpr-modal .error-box{
    margin-top:4em
  }
}

text.color-legend{
  font-family:"Raleway","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:10px
}

text.exp-map-xlabel{
  font-family:"Raleway","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:10px
}

text.exp-map-xlabel.highlighted{
  font-weight:400;
  font-size:12px;
  text-decoration:underline
}

text.exp-map-xlabel.query{
  font-weight:600;
  font-size:11px;
  fill:#d2111b
}

text.exp-map-ylabel{
  font-family:"Raleway","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:10px
}

text.exp-map-ylabel.highlighted{
  font-weight:400;
  font-size:12px;
  text-decoration:underline
}

text.exp-map-ylabel.clicked,text.exp-map-xlabel.clicked{
  fill:#d25c43
}

rect.exp-map-cell{
  stroke-width:0px
}

rect.exp-map-cell.highlighted{
  stroke:#d25c43;
  stroke-width:2px
}

div.heatmap-tooltip{
  min-width:100px;
  display:none;
  background-color:rgba(32,53,73,.95);
  padding:10px;
  text-align:left;
  color:#fff;
  position:absolute;
  font-size:12px;
  z-index:4000;
  border-radius:5px
}

.charts-container{
  display:flex;
  flex-wrap:wrap
}

.chart{
  flex:0 0 100%;
  border:1px solid #ddd;
  padding:5px;
  border-radius:4px;
  margin:0px 0 5px;
  position:relative;
  overflow:hidden
}

.chart .chart{
  width:100%;
  height:100%;
  margin:0 !important;
  padding:0;
  flex:1;
  border:none
}

.chart .chart .custom-container{
  width:100%;
  height:100%;
  display:flex;
  align-items:center
}

@media(min-width: 1024px){
  .chart{
    flex:0 0 calc(50% - 5px)
  }

  .chart:nth-of-type(odd){
    margin-right:5px
  }
}

@media(min-width: 1367px){
  .chart{
    padding:10px;
    margin:0px 0 10px;
    flex:0 0 calc(33% - 4px)
  }

  .chart:nth-of-type(odd){
    margin-right:0
  }

  .chart:nth-of-type(3n + 2){
    margin-left:10px;
    margin-right:10px
  }
}

.chart canvas{
  width:100%;
  height:auto;
  display:block
}

.chart--vertical{
  width:100%;
  height:auto
}

.chart--empty{
  width:200px;
  height:160px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  background-color:#f7f7f7;
  padding:0 20px;
  text-align:center;
  margin:0 auto
}

.chart--empty *{
  color:#577396
}

.chart--empty i{
  font-size:1.8rem;
  display:flex;
  justify-content:center;
  color:#577396
}

.chart--empty p{
  padding:1rem 0 0 0;
  color:#577396
}

.chart--empty .emphasize{
  font-weight:600;
  color:#4e6075
}

.chart--premium{
  width:200px;
  height:160px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  background-color:#f7f7f7;
  padding:0 20px;
  text-align:center;
  margin:0 auto
}

.chart--premium *{
  color:#2ca591
}

.chart--premium i{
  font-size:1.8rem;
  display:flex;
  justify-content:center;
  color:#2ca591
}

.chart--premium p{
  padding:1rem 0 0 0;
  color:#000
}

.chart--premium .emphasize{
  font-weight:600;
  color:#000
}

.hidden{
  display:none !important
}

.prisma_tables .table-container{
  overflow-y:auto
}

.varsome_table{
  border-collapse:collapse;
  min-width:300px;
  width:initial;
  margin-bottom:0
}

.varsome_table table{
  width:100%
}

.varsome_table tr{
  width:100%
}

.varsome_table th,.varsome_table td{
  box-sizing:border-box;
  padding:10px;
  font-size:12px
}

.varsome_table td{
  border:1px solid #eceeef
}

.varsome_table thead th{
  background:#f5f5f5;
  color:#373a3c;
  text-align:center;
  line-height:1.5em;
  border-bottom:1px solid #3cdbc0;
  font-weight:400
}

.varsome_table tbody{
  text-align:left
}

.varsome_table tbody td{
  font-weight:bold
}

.varsome_table tbody td.font-normal{
  font-weight:normal
}

.varsome_table .numeric{
  text-align:right;
  width:1%;
  white-space:nowrap
}

.varsome_table .center{
  text-align:center
}

.varsome_table .left{
  text-align:left
}

.varsome_table.full-width{
  width:100%
}

.varsome_table tr.highlight td{
  background-color:#dde3ea
}

.varsome_table--reset-bold-td td{
  font-weight:normal !important
}

.varsome_table--stripped-hover tr:hover td{
  background-color:#fff
}

.varsome_table--roboto{
  font-family:"Roboto",sans-serif
}

.varsome_table--td-th-no-wrap td,.varsome_table--td-th-no-wrap th{
  white-space:nowrap
}

.sources_table table{
  position:relative
}

.sources_table td{
  background-color:#f1f0f0
}

.sources_table tr.negative td{
  background-color:#fff
}

.sources_table .fit{
  width:1%;
  white-space:nowrap
}

.sources_table th{
  position:-webkit-sticky;
  position:sticky;
  top:100px;
  z-index:2;
  background-color:#d7e1eb !important
}

.saph-green-btn{
  display:inline-block;
  margin-right:8px;
  border-radius:0px;
  cursor:pointer;
  padding-left:24px;
  padding-right:24px;
  padding-top:8px;
  padding-bottom:8px;
  font-weight:500;
  font-size:14px;
  line-height:20px;
  text-decoration:none;
  transition-duration:300ms;
  transition-property:all;
  border-width:1px;
  --border-opacity:1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity));
  --bg-opacity:1;
  background-color:#2ca591;
  background-color:rgba(44, 165, 145, var(--bg-opacity));
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity))
}

.saph-green-btn:hover{
  --bg-opacity:1;
  background-color:#35C5AD;
  background-color:rgba(53, 197, 173, var(--bg-opacity));
  --border-opacity:1;
  border-color:#35C5AD;
  border-color:rgba(53, 197, 173, var(--border-opacity))
}

.saph-white-ghost{
  display:inline-block;
  cursor:pointer;
  margin-right:8px;
  margin-bottom:4px;
  border-radius:2px;
  transition-duration:300ms;
  transition-property:all;
  border-width:1px;
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241, 245, 249, var(--border-opacity));
  padding-left:4px;
  padding-right:4px;
  padding-top:2px;
  padding-bottom:2px
}

.saph-green-ghost{
  display:inline-block;
  cursor:pointer;
  margin-right:8px;
  border-radius:2px;
  transition-duration:300ms;
  transition-property:all;
  font-size:14px;
  line-height:20px;
  padding:8px;
  border-width:1px;
  --text-opacity:1;
  color:#2ca591;
  color:rgba(44, 165, 145, var(--text-opacity));
  --border-opacity:1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity))
}

.saph-green-ghost--small{
  display:inline-block;
  cursor:pointer;
  margin-right:4px;
  margin-bottom:4px;
  border-radius:2px;
  transition-duration:300ms;
  transition-property:all;
  font-size:14px;
  line-height:20px;
  padding-left:4px;
  padding-right:4px;
  border-width:1px;
  --text-opacity:1;
  color:#2ca591;
  color:rgba(44, 165, 145, var(--text-opacity));
  --border-opacity:1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity))
}

.saph-green-ghost--small.active{
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  --bg-opacity:1;
  background-color:#2ca591;
  background-color:rgba(44, 165, 145, var(--bg-opacity))
}

.saph-combo-button{
  display:inline-block;
  cursor:pointer;
  margin-right:8px;
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  border-radius:2px;
  font-size:14px;
  line-height:20px;
  padding:0px;
  border-width:1px;
  --border-opacity:1;
  border-color:#f5f5f4;
  border-color:rgba(245, 245, 244, var(--border-opacity))
}

.saph-combo-button>.saph-button{
  margin-right:0px;
  border-style:none;
  border-radius:0px
}

.btn.disabled,.btn:disabled{
  cursor:not-allowed;
  opacity:.45 !important
}

.radiobuttons{
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale
}

.radiobuttons .radiobutton{
  margin:0 0 16px 0
}

.radiobuttons .radiobutton:last-of-type .label{
  padding-right:0
}

.radiobuttons .radiobutton input[type=radio]{
  display:none
}

.radiobuttons .radiobutton input[type=radio]:checked+label:before{
  border-color:#2ca591;
  animation:ripple .2s linear forwards
}

.radiobuttons .radiobutton input[type=radio]:checked+label:after{
  transform:scale(1)
}

.radiobuttons .radiobutton input[type=radio]:disabled+label{
  color:rgba(0,0,0,.42);
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none
}

.radiobuttons .radiobutton input[type=radio]:disabled+label:before{
  border-color:rgba(0,0,0,.24)
}

.radiobuttons .radiobutton label{
  display:inline-block;
  height:20px;
  position:relative;
  padding:0 30px;
  margin-bottom:0;
  cursor:pointer;
  vertical-align:bottom
}

.radiobuttons .radiobutton label:before,.radiobuttons .radiobutton label:after{
  position:absolute;
  content:"";
  border-radius:50%;
  transition:all .3s ease;
  transition-property:transform,border-color
}

.radiobuttons .radiobutton label:before{
  left:0;
  top:0;
  width:20px;
  height:20px;
  border:2px solid #9696a0
}

.radiobuttons .radiobutton label:after{
  top:calc(20px/2 - 10px/2);
  left:calc(20px/2 - 10px/2);
  width:10px;
  height:10px;
  transform:scale(0);
  background:#2ca591
}

.radiobuttons .radiobutton .info-text{
  font-size:10px;
  margin:2px 0 0 0;
  font-style:italic;
  line-height:1em;
  -webkit-user-select:none;
          user-select:none
}

.radiobuttons--inline{
  display:inline-flex;
  flex-wrap:wrap;
  margin-right:16px
}

.radiobuttons--inline:last-child{
  margin-right:0
}

.radiobuttons--small .radiobutton{
  margin-bottom:0px
}

.radiobuttons--small .radiobutton label{
  height:14px;
  padding:0px 10px 0px 16px
}

.radiobuttons--small .radiobutton label:before{
  width:14px;
  height:14px;
  border:1px solid #9696a0
}

.radiobuttons--small .radiobutton label:after{
  top:3px;
  left:3px;
  width:8px;
  height:8px
}

@keyframes ripple{
  0%{
    box-shadow:0px 0px 0px 1px rgba(0,0,0,0)
  }

  50%{
    box-shadow:0px 0px 0px 15px rgba(0,0,0,.1)
  }

  100%{
    box-shadow:0px 0px 0px 15px rgba(0,0,0,0)
  }
}

.icon-xxs{
  width:14px;
  height:14px;
  display:inline-block
}

.noselect{
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  user-select:none
}

.saph-pill{
  min-width:200px;
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  font-weight:600;
  border-radius:24px;
  font-size:16px;
  line-height:24px;
  padding-top:4px;
  padding-bottom:4px;
  padding-left:12px;
  padding-right:12px;
  text-align:center
}

.saph-pill.saph-pill-amp{
  min-width:150px
}

.legend__header .desc{
  font-size:11px;
  font-style:italic;
  margin-left:4px
}

.legend .varsome_table{
  min-width:initial;
  margin-bottom:1.25rem
}

.legend .varsome_table .numeric{
  font-weight:400;
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif
}

.legend .checkbox label{
  margin-bottom:0
}

.pub-expanded .abstract-text .pub-text-label{
  margin-top:1.5em;
  font-size:.8em;
  font-weight:bold
}

.pub-expanded .abstract-text:first-child .pub-text-label{
  margin-top:0px
}

.pub-expanded .pub-text-label{
  line-height:1em;
  font-size:.8em;
  font-weight:bold
}

.pub-expanded .copyright-text{
  font-size:.9em;
  margin-top:1em
}

.pub-collapsed .abstract-text .pub-text-label{
  margin-right:8px;
  display:inline-block
}

.pub-collapsed .pub-text-label{
  line-height:1em;
  font-size:1em;
  font-weight:normal
}

.pub-collapsed .abstract-cuttof-t{
  background-image:linear-gradient(to top, var(--gradient-color-stops));
  --gradient-from-color:rgba(255,255,255,0.001);
  --gradient-color-stops:var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  --gradient-to-color:#fff;
  height:4px
}

.pub-collapsed .abstract-cuttof-b{
  background-image:linear-gradient(to bottom, var(--gradient-color-stops));
  --gradient-from-color:rgba(255,255,255,0.001);
  --gradient-color-stops:var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  --gradient-to-color:#fff;
  height:4px
}

.pub-collapsed .tags-cuttof{
  background-image:linear-gradient(to right, var(--gradient-color-stops));
  --gradient-to-color:#fff;
  --gradient-from-color:rgba(255,255,255,0.001);
  --gradient-color-stops:var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  height:16px
}

.pub-collapsed:hover .abstract-cuttof{
  background-image:linear-gradient(to bottom, var(--gradient-color-stops));
  --gradient-to-color:#fff;
  --gradient-from-color:rgba(255,255,255,0.001);
  --gradient-color-stops:var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0))
}

*,::before,::after{
  box-sizing:border-box;
  border-width:0;
  border-style:solid;
  border-color:#d4d4d8
}

@media(min-width: 1200px){
  .container{
    max-width:1340px !important
  }
}

.varsome-request-container{
  font-family:"Raleway","Helvetica Neue",Helvetica,Arial,sans-serif;
  width:100%;
  margin:0 auto;
  text-align:center
}

.varsome-request-container .varsome-variant-chooser .varsome-variant-option{
  margin:1rem 0;
  margin-left:.8rem
}

.varsome-request-container .varsome-variant-chooser .varsome-variant-option a{
  padding:.5rem;
  cursor:pointer;
  color:#2ca591
}

.varsome-request-container .varsome-variant-chooser .varsome-variant-option a.selected{
  color:#373a3c;
  font-weight:bold;
  background-color:#e5e5e5
}

.varsome-request-error{
  width:100%;
  margin:10% 0;
  padding:1rem 0;
  background-color:#e69d9d;
  color:#fff;
  white-space:pre-line
}

.varsome-request-error a{
  color:#fff;
  font-weight:bold
}

.varsome-request-error a:hover{
  color:#fff;
  font-weight:bold;
  text-decoration:underline
}

.varsome-collapse-arrow{
  position:relative;
  text-align:center
}

.varsome-collapse-arrow span{
  position:absolute;
  font-size:.5rem;
  top:0
}

.varsome-collapse-arrow i{
  position:absolute;
  top:6px;
  left:4px
}

.varsome-collapse-arrow i.open{
  left:3px
}

.btn-action{
  font-size:1rem;
  cursor:pointer;
  margin-right:1rem;
  color:#ddd;
  padding:.25rem 1rem;
  border:2px solid #ddd;
  font-weight:normal;
  border-radius:3px;
  margin-top:5px;
  display:inline-block;
  vertical-align:middle
}

.btn-action:hover{
  text-decoration:none !important;
  color:#fff;
  border:2px solid #fff
}

.btn-action:visited,.btn-action:focus{
  text-decoration:none !important;
  color:#ddd
}

.btn-action.active{
  background-color:#2ca591
}

.links:visited{
  color:#2ca591 !important
}

.varsome-genome-browser{
  user-drag:none;
  background-color:#fff
}

.varsome-genome-browser text{
  user-drag:none;
  -webkit-user-select:none !important;
          user-select:none !important
}

.varsome-genome-browser .nearby-variant{
  cursor:pointer
}

.varsome-genome-browser-container{
  background-color:#f5f5f5;
  position:relative
}

.varsome-genome-browser-container.full{
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:10000;
  background-color:#fff
}

.varsome-genome-browser-container .varsome-browser-controls .btn-action{
  background-color:#fff;
  margin-top:-0.3rem
}

.varsome-genome-browser-container .varsome-browser-controls .btn-action:hover{
  border:2px solid #bbb
}

.varsome-genome-browser-legend{
  padding:.2rem .5rem;
  position:absolute;
  right:.5rem;
  background-color:rgba(255,255,255,.9);
  border:1px solid #ddd;
  z-index:1
}

.varsome-citations{
  font-size:.8rem;
  padding:1rem 2rem 0 1rem
}

.varsome-citations p{
  color:#818a91 !important
}

.dbnsfp-row td{
  padding:1rem .5rem;
  vertical-align:top;
  text-align:left
}

.varsome-tooltip{
  z-index:10002 !important;
  text-align:center
}

.varsome-left{
  float:left
}

.varsome-right{
  float:right
}

.varsome-clearfix:after{
  visibility:hidden;
  display:block;
  font-size:0;
  content:" ";
  clear:both;
  height:0
}

.varsome-hidden{
  display:none
}

.varsome-bg-success{
  background-color:#3cdbc0
}

.varsome-text-muted{
  color:#818a91 !important
}

.varsome-text-success{
  color:#3cdbc0 !important
}

.varsome-text-center{
  text-align:center
}

.varsome-table{
  table-layout:fixed
}

.varsome-table tr.highlight td{
  background-color:#fff
}

.varsome-table,.varsome-table-overflow{
  width:100%;
  border-spacing:0;
  border-collapse:collapse
}

.varsome-table tr,.varsome-table-overflow tr{
  border-top:1px solid #eceeef
}

.varsome-table th,.varsome-table-overflow th{
  padding:10px;
  font-weight:bold;
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  border-bottom:1px solid #3cdbc0
}

.varsome-table td,.varsome-table-overflow td{
  padding:10px;
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  word-wrap:break-word
}

.varsome-table td span,.varsome-table td a,.varsome-table td div,.varsome-table-overflow td span,.varsome-table-overflow td a,.varsome-table-overflow td div{
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  word-wrap:break-word
}

.varsome-table td .varsome-dbnsfp-label,.varsome-table-overflow td .varsome-dbnsfp-label{
  font-family:"Raleway","Helvetica Neue",Helvetica,Arial,sans-serif
}

.varsome-table tr.varsome-bg-success td,.varsome-table-overflow tr.varsome-bg-success td{
  color:#fff
}

.varsome-table tr.varsome-table-totals.gnomad-font-normal,.varsome-table-overflow tr.varsome-table-totals.gnomad-font-normal{
  font-weight:normal
}

.varsome-table tr.varsome-table-totals,.varsome-table-overflow tr.varsome-table-totals{
  font-weight:bold;
  border-top:1px solid #3cdbc0
}

.varsome-table .gnomad-af-td-padding,.varsome-table-overflow .gnomad-af-td-padding{
  padding-left:95px
}

.varsome-table .varsome-cell-total,.varsome-table-overflow .varsome-cell-total{
  font-weight:bold
}

.varsome-pubmed-table-row:hover{
  background-color:#eee;
  cursor:pointer
}

.varsome-gene-stats-table tr{
  border-top:2px solid #999
}

.varsome-gene-stats-table tr.varsome-table-totals{
  border-top:2px solid #3cdbc0
}

.varsome-gene-stats-table .fade-row td{
  color:#ccc
}

.varsome-gene-link{
  color:#fff !important;
  font-size:12px;
  font-weight:600 !important;
  text-decoration:none !important;
  margin:.5rem .8rem .5rem 0;
  padding:.25rem .5rem;
  background-color:#40bbea;
  display:inline-block
}

.varsome-gene-link:hover{
  background-color:#3396ba
}

.varsome-truncated-seq{
  text-decoration:underline;
  cursor:pointer
}

.truncated-text{
  text-decoration:underline;
  cursor:pointer;
  color:#373a3c
}

.varsome-pubmed-article-short{
  padding:.4rem .75rem;
  border:1px solid #ccc;
  margin-bottom:.5rem;
  font-size:.9rem;
  position:relative
}

.varsome-pubmed-article-short h6{
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:1.2rem
}

.varsome-pubmed-article-short h4{
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:1.2rem
}

.varsome-pubmed-article-short p{
  margin-bottom:.4rem
}

.varsome-horiz-flex{
  display:flex;
  flex-direction:row;
  flex-wrap:wrap
}

.varsome-horiz-list-item{
  padding:15px;
  flex-grow:1;
  text-align:center
}

.varsome-horiz-list-label{
  font-size:.8rem;
  color:#818a91
}

.varsome-expander{
  display:block;
  cursor:pointer
}

.embeded-genes .varsome-result .varsome-container,.embeded-genes .varsome-result-fixed .varsome-container{
  border:.1px solid #e5e5e5;
  border-top:1px solid #e5e5e5
}

.embeded-genes .varsome-result .varsome-title,.embeded-genes .varsome-result-fixed .varsome-title{
  border-bottom:1px solid #e5e5e5
}

.genes-page .varsome-result .varsome-container,.genes-page .varsome-result-fixed .varsome-container{
  border:1px solid #e5e5e5
}

.varsome-result,.varsome-result-fixed{
  font-family:"Roboto","Arimo","Helvetica Neue",Helvetica,Arial,sans-serif;
  box-sizing:border-box;
  color:#373a3c;
  line-height:1.5
}

.varsome-result a,.varsome-result-fixed a{
  color:#2ca591;
  text-decoration:none;
  cursor:pointer
}

.varsome-result a.varsome-white-link,.varsome-result-fixed a.varsome-white-link{
  text-decoration:underline;
  color:#fff
}

.varsome-result a:hover,.varsome-result-fixed a:hover{
  color:#3cdbc0;
  text-decoration:underline
}

.varsome-result a span,.varsome-result a small,.varsome-result a i,.varsome-result-fixed a span,.varsome-result-fixed a small,.varsome-result-fixed a i{
  color:#2ca591;
  text-decoration:none
}

.varsome-result .varsome-container,.varsome-result-fixed .varsome-container{
  border:1px solid #e5e5e5;
  width:100%;
  margin:0 auto .9375rem auto !important;
  background-color:#fff
}

.varsome-result .varsome-container.varsome-container__basic,.varsome-result-fixed .varsome-container.varsome-container__basic{
  margin-bottom:0px !important;
  background-color:#fff;
  border:none !important
}

.varsome-result .varsome-container.varsome-container__basic .varsome-title,.varsome-result-fixed .varsome-container.varsome-container__basic .varsome-title{
  background-color:rgba(0,0,0,0);
  border:none;
  border-bottom:1px solid #e5e5e5
}

.varsome-result .varsome-title,.varsome-result-fixed .varsome-title{
  display:block;
  width:100%;
  background-color:#f5f5f5;
  border-bottom:.1rem solid #e5e5e5;
  font-size:1rem;
  padding:.75rem 2.5rem .75rem 1.25rem;
  position:relative
}

.varsome-result .varsome-title small,.varsome-result-fixed .varsome-title small{
  margin-left:.5rem;
  font-size:.8rem
}

.varsome-result .varsome-genes-title,.varsome-result-fixed .varsome-genes-title{
  margin:0 0 1.25rem -1rem;
  width:calc(100% + 2rem);
  border-top:1px solid #e5e5e5
}

.varsome-result .varsome-subtitle,.varsome-result-fixed .varsome-subtitle{
  font-size:1.5rem;
  margin-bottom:.75rem;
  font-weight:300
}

.varsome-result .varsome-subtitle small,.varsome-result-fixed .varsome-subtitle small{
  margin-left:.5rem;
  font-size:.8rem
}

.varsome-result .varsome-inner-container,.varsome-result-fixed .varsome-inner-container{
  background-color:#fff;
  padding:1.25rem
}

.varsome-result .varsome-inner-container .premium-badge-container,.varsome-result-fixed .varsome-inner-container .premium-badge-container{
  display:none
}

.varsome-result .varsome-inner-container .premium-badge-container img,.varsome-result-fixed .varsome-inner-container .premium-badge-container img{
  height:14px;
  width:auto;
  margin-left:4px;
  display:inline-block
}

.varsome-result .varsome-subcontainer,.varsome-result-fixed .varsome-subcontainer{
  padding:0 1rem 1rem 1rem;
  margin-bottom:2rem
}

.varsome-result .varsome-sequence-container,.varsome-result-fixed .varsome-sequence-container{
  background-color:#fff;
  padding:1.25rem;
  border-top:.1rem solid #e5e5e5;
  text-align:center;
  display:flex;
  flex-wrap:nowrap;
  justify-content:center
}

.varsome-result .varsome-sequence-container *,.varsome-result-fixed .varsome-sequence-container *{
  font-family:"Cutive Mono","Menlo","Monaco","Consolas","Courier New"
}

.varsome-result .varsome-sequence-container .varsome-sequence-small,.varsome-result-fixed .varsome-sequence-container .varsome-sequence-small{
  vertical-align:top;
  color:#818a91;
  font-size:1.5rem;
  margin-top:4.5rem;
  overflow:hidden;
  flex:1 0
}

.varsome-result .varsome-sequence-container .varsome-sequence-small.before,.varsome-result-fixed .varsome-sequence-container .varsome-sequence-small.before{
  text-align:right;
  direction:rtl
}

.varsome-result .varsome-sequence-container .varsome-sequence-large,.varsome-result-fixed .varsome-sequence-container .varsome-sequence-large{
  font-size:3rem;
  margin:0 1rem
}

.varsome-result .varsome-sequence-container .val-text,.varsome-result-fixed .varsome-sequence-container .val-text{
  color:inherit;
  line-height:3rem;
  margin-top:-0.7rem
}

.varsome-result .varsome-sequence-container .val-text.red span,.varsome-result-fixed .varsome-sequence-container .val-text.red span{
  color:#c19999
}

.varsome-result .varsome-sequence-container .val-text.green span,.varsome-result-fixed .varsome-sequence-container .val-text.green span{
  color:#059669
}

.varsome-result .varsome-sequence-container .pos-text,.varsome-result-fixed .varsome-sequence-container .pos-text{
  color:inherit;
  font-size:.75rem
}

.varsome-result .varsome-equivalent-indels,.varsome-result-fixed .varsome-equivalent-indels{
  border-top:.1rem solid #e5e5e5;
  text-align:center
}

.varsome-result .varsome-equivalent-indels .varsome-small-subtitle,.varsome-result-fixed .varsome-equivalent-indels .varsome-small-subtitle{
  color:#818a91;
  margin-bottom:1rem
}

.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel{
  overflow:hidden;
  display:flex;
  flex-wrap:nowrap;
  justify-content:center
}

.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel .indel-seq-container,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel .indel-seq-container{
  max-width:60%;
  overflow:hidden;
  display:flex;
  flex-wrap:nowrap;
  justify-content:center
}

.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel .indel-seq-container *,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel .indel-seq-container *{
  display:inline-block;
  color:#818a91;
  font-family:"Cutive Mono","Menlo","Monaco","Consolas","Courier New"
}

.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel .before-highlight,.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel .after-highlight,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel .before-highlight,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel .after-highlight{
  color:orange
}

.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel .middle,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel .middle{
  display:inline-block
}

.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel .middle.deletion *,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel .middle.deletion *{
  color:#2ca591;
  text-decoration:line-through
}

.varsome-result .varsome-equivalent-indels .varsome-equivalent-indel .middle.insertion *,.varsome-result-fixed .varsome-equivalent-indels .varsome-equivalent-indel .middle.insertion *{
  color:#059669
}

.varsome-result .varsome-genes-container,.varsome-result-fixed .varsome-genes-container{
  background-color:#fafafa
}

.varsome-result .varsome-tabs,.varsome-result-fixed .varsome-tabs{
  list-style:none;
  padding:0;
  margin:0;
  position:relative
}

.varsome-result .varsome-tab,.varsome-result-fixed .varsome-tab{
  float:left
}

.varsome-result .varsome-tab a,.varsome-result-fixed .varsome-tab a{
  display:block;
  padding:.5rem 1rem;
  cursor:pointer;
  text-decoration:none;
  border:1px solid #e5e5e5;
  background-color:#fff;
  z-index:2
}

.varsome-result .varsome-tab a:hover,.varsome-result-fixed .varsome-tab a:hover{
  background-color:#ccc;
  color:#fff
}

.varsome-result .varsome-tab a.selected,.varsome-result-fixed .varsome-tab a.selected{
  border-bottom:1px solid #fff;
  font-weight:600;
  color:#373a3c
}

.varsome-result .varsome-tab a.selected:hover,.varsome-result-fixed .varsome-tab a.selected:hover{
  background-color:#fff
}

.varsome-result .varsome-tab:not(:first-child),.varsome-result-fixed .varsome-tab:not(:first-child){
  margin-left:1rem
}

.varsome-result .varsome-tab-container,.varsome-result-fixed .varsome-tab-container{
  padding:0rem;
  background-color:#fff;
  border:1px solid #e5e5e5;
  margin-top:-1px
}

.varsome-result .varsome-canonical-row,.varsome-result-fixed .varsome-canonical-row{
  background-color:#eee
}

.varsome-result .varsome-canonical-row a:hover,.varsome-result-fixed .varsome-canonical-row a:hover{
  color:#ccc
}

.varsome-result .varsome-canonical-row span,.varsome-result-fixed .varsome-canonical-row span{
  color:#fff
}

.varsome-result .varsome-legend,.varsome-result-fixed .varsome-legend{
  margin-top:.5rem
}

.varsome-result .varsome-legend .varsome-canonical-box,.varsome-result-fixed .varsome-legend .varsome-canonical-box{
  display:inline-block;
  width:3rem;
  height:1.2rem;
  background-color:#eee
}

.varsome-result .varsome-legend span,.varsome-result-fixed .varsome-legend span{
  vertical-align:middle
}

.varsome-result .varsome-blockquote,.varsome-result-fixed .varsome-blockquote{
  margin:0;
  padding:.5rem 1rem;
  border-left:.25rem solid #eceeef;
  margin-bottom:1rem
}

.varsome-result .varsome-blockquote a,.varsome-result-fixed .varsome-blockquote a{
  font-size:1.25rem
}

.varsome-result .varsome-blockquote footer *,.varsome-result-fixed .varsome-blockquote footer *{
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:1rem;
  color:#818a91
}

.varsome-result .varsome-blockquote footer a,.varsome-result-fixed .varsome-blockquote footer a{
  color:#3cdbc0
}

.varsome-result .varsome-blockquote cite,.varsome-result-fixed .varsome-blockquote cite{
  margin-left:1rem
}

.varsome-result .aact-blockquote a,.varsome-result-fixed .aact-blockquote a{
  font-size:1rem
}

.varsome-result .aact-blockquote footer *,.varsome-result-fixed .aact-blockquote footer *{
  font-size:.85rem
}

.varsome-result .varsome-label,.varsome-result-fixed .varsome-label{
  background-color:#818a91;
  color:#fff;
  font-size:75%;
  padding:.25rem .4rem;
  font-weight:700;
  line-height:1;
  margin:0 0 0 .5rem
}

.varsome-result .varsome-drug-list-item,.varsome-result-fixed .varsome-drug-list-item{
  font-size:1rem
}

.varsome-result .varsome-drug-list-item a,.varsome-result-fixed .varsome-drug-list-item a{
  display:inline-block;
  word-break:break-all
}

.varsome-result .varsome-drug-list-item .varsome-label,.varsome-result-fixed .varsome-drug-list-item .varsome-label{
  margin-top:1px;
  display:inline-block;
  word-break:keep-all
}

.varsome-result .varsome-comment-container,.varsome-result-fixed .varsome-comment-container{
  margin-bottom:1rem;
  border-bottom:.1rem solid #e5e5e5
}

.varsome-result .varsome-comment-container .varsome-comment p.varsome-comment-text,.varsome-result-fixed .varsome-comment-container .varsome-comment p.varsome-comment-text{
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size:1rem;
  white-space:pre-wrap
}

.varsome-result .varsome-comment-container .varsome-comment p.varsome-comment-text a,.varsome-result-fixed .varsome-comment-container .varsome-comment p.varsome-comment-text a{
  font-size:1rem
}

.varsome-result .varsome-comment-container .varsome-comment cite,.varsome-result-fixed .varsome-comment-container .varsome-comment cite{
  margin-left:.4rem
}

.varsome-result .varsome-dl-horizontal,.varsome-result-fixed .varsome-dl-horizontal{
  margin-left:0;
  margin-right:0;
  padding-top:1rem;
  border:.1rem solid #e5e5e5
}

.varsome-inline-label{
  margin-right:1rem
}

.varsome-inline-label input{
  margin-right:.25rem
}

.form-check-label{
  cursor:pointer
}

.ReactModal__Body--open{
  overflow:hidden
}

.varsome-acmg-link{
  font-size:1rem;
  cursor:pointer;
  color:#2ca591
}

.varsome-acmg-options{
  display:inline-block !important;
  padding:.375rem 1rem !important;
  margin-right:.5rem !important;
  font-size:1rem !important;
  white-space:nowrap !important;
  cursor:pointer !important;
  color:#2ca591 !important;
  background-color:#fff !important;
  border-radius:2px !important;
  line-height:1.25 !important;
  text-align:center !important;
  -webkit-user-select:none !important;
          user-select:none !important;
  border:1px solid #2ca591 !important
}

.varsome-connect-button{
  text-align:center
}

.varsome-connect-button a{
  color:#fff !important;
  background-color:#2ca591;
  border-color:#2ca591;
  padding:.5rem 1rem;
  line-height:1.25
}

.varsome-connect-button a:hover{
  color:#fff !important;
  text-decoration:none;
  background-color:#217d6e;
  border-color:#1f7567
}

.varsome-result .varsome-connect-button,.varsome-result-fixed .varsome-connect-button{
  text-align:center
}

.varsome-result .varsome-connect-button a:not([href]):not([tabindex]),.varsome-result-fixed .varsome-connect-button a:not([href]):not([tabindex]){
  color:#fff !important;
  background-color:#2ca591;
  border-color:#2ca591;
  padding:.5rem 1rem;
  line-height:1.25
}

.varsome-result .varsome-connect-button a:not([href]):not([tabindex]):hover,.varsome-result-fixed .varsome-connect-button a:not([href]):not([tabindex]):hover{
  color:#fff !important;
  text-decoration:none !important;
  background-color:#217d6e;
  border-color:#1f7567
}

.varsome-result a.close-btn:not([href]):not([tabindex]):focus,.varsome-result a.close-btn:not([href]):not([tabindex]):hover,.varsome-result-fixed a.close-btn:not([href]):not([tabindex]):focus,.varsome-result-fixed a.close-btn:not([href]):not([tabindex]):hover{
  color:#1c695c !important;
  text-decoration:none !important
}

.varsome-result a:not([href]):not([tabindex]):hover,.varsome-result-fixed a:not([href]):not([tabindex]):hover{
  color:#3cdbc0 !important;
  text-decoration:underline !important
}

a.close-btn:not([href]):not([tabindex]):focus,a.close-btn:not([href]):not([tabindex]):hover{
  color:#1c695c !important;
  text-decoration:none !important
}

a.btn-action:not([href]):not([tabindex]):focus,a.btn-action:not([href]):not([tabindex]):hover{
  text-decoration:none !important
}

.varsome-result .varsome-table a:not([href]):not([tabindex]):hover,.varsome-result .varsome-clearfix a:not([href]):not([tabindex]):hover,.varsome-result-fixed .varsome-table a:not([href]):not([tabindex]):hover,.varsome-result-fixed .varsome-clearfix a:not([href]):not([tabindex]):hover{
  color:#3cdbc0 !important;
  text-decoration:underline !important
}

.container-fluid a.btn-action:not([href]):not([tabindex]),.container-fluid a.btn-action:not([href]):not([tabindex]):focus,.container-fluid a.btn-action:not([href]):not([tabindex]):hover{
  color:#fff !important
}

.varsome-result a:not([href]):not([tabindex]),.varsome-result-fixed a:not([href]):not([tabindex]),.container-fluid a:not([href]):not([tabindex]){
  color:#2ca591 !important
}

.varsome-result a:not([href]):not([tabindex]):focus,.varsome-result a:not([href]):not([tabindex]):hover,.varsome-result-fixed a:not([href]):not([tabindex]):focus,.varsome-result-fixed a:not([href]):not([tabindex]):hover,.container-fluid a:not([href]):not([tabindex]):focus,.container-fluid a:not([href]):not([tabindex]):hover{
  color:#1c695c;
  text-decoration:underline
}

.result-chooser a:not([href]):not([tabindex]):hover{
  color:#fff !important
}

.result-chooser a:not([href]):not([tabindex]){
  color:#ccc !important
}

.result-chooser a.selected:not([href]):not([tabindex]){
  color:#fff !important
}

.btn.cancel-button{
  background-color:#e5e5e5 !important
}

#nav-side .nav{
  display:block !important
}

.genome-btn-group{
  display:inline-block !important
}

.btn.btn-info{
  color:#fff !important
}

.popup-controls a:not([href]):not([tabindex]){
  color:#2ca591
}

.popup-controls a:not([href]):not([tabindex]):hover{
  color:#1c695c
}

.popup-controls .btn-success{
  color:#fff !important
}

.radio-btns-pubs input[type=radio]{
  opacity:0
}

.radio-btns-pubs input[type=radio]+label{
  font-size:.9em;
  cursor:pointer;
  border:1px solid #ccc;
  padding:3px 10px
}

.radio-btns-pubs input[type=radio]+label{
  display:inline-block;
  width:310px;
  cursor:pointer;
  background-color:#fff
}

.radio-btns-pubs input[type=radio]:checked+label{
  background-color:rgba(44,165,145,.25);
  font-weight:bold
}

#fullNameToolTip{
  max-width:30vw !important
}

.article-modal{
  width:90% !important;
  max-width:800px !important
}

.varsome-table-sorted th.th-sort{
  text-align:left
}

.varsome-table-sorted th.th-sort .sort-container{
  padding-left:7px;
  padding-top:5px
}

.varsome-table-sorted th.th-sort .sort-container .sort-dir{
  color:gray;
  font-size:7px;
  font-weight:400px;
  opacity:.5
}

.varsome-table-sorted th.th-sort .sort-container i{
  font-size:14px;
  color:gray;
  opacity:.5
}

.varsome-table-sorted th.th-sort .sort-container .sort-icon-container{
  margin-top:-5px
}

.varsome-table-sorted .th-sort.active .sort-container .sort-dir,.varsome-table-sorted .th-sort.active .sort-container i{
  color:#2ca591;
  opacity:1
}

.varsome-table-sorted .th-sort:hover{
  background-color:#f5f5f5
}

.varsome-table-sorted .th-sort.center{
  text-align:center
}

.tag{
  border-radius:3px;
  font-weight:600;
  font-size:.9rem;
  opacity:.7;
  display:inline-block;
  margin-right:5px;
  margin-top:5px;
  padding:4px 7px 4px 7px;
  cursor:default;
  transition:opacity .2s linear
}

.tooltip-text{
  letter-spacing:.06em;
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif
}

.font-cabin{
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif
}

.font-raleway{
  font-family:"Raleway","Helvetica Neue",Helvetica,Arial,sans-serif
}

.premiumUser .varsome-inner-container .premium-badge-container{
  margin-bottom:5px;
  display:inline-block
}

.primary-link{
  color:#2ca591 !important
}

.comment-content p{
  margin:0px
}

.error-rectangle-box{
  margin-top:16px;
  border-radius:4px;
  background-color:rgba(206,49,49,.15)
}

.error-box-text{
  padding:16px;
  color:#ce3131;
  font-size:16px;
  letter-spacing:0;
  line-height:24px
}

.warning-rectangle-box{
  margin-top:16px;
  border-radius:4px;
  background-color:rgba(223,180,0,.2)
}

.warning-box-text{
  padding:16px;
  color:#8d7206;
  font-size:16px;
  letter-spacing:0;
  line-height:24px
}

.cms-modal .cms-modal__header{
  padding-right:45px
}

.cms-modal .cms-modal__header h1 p{
  margin-bottom:0
}

.cms-modal .cms-modal__closeBtn{
  top:3px
}

.cms-modal .cms-modal__body ul>li{
  margin-bottom:8px
}

.cms-modal .cms-modal__footer{
  text-align:center;
  border-top:1px solid #d4d4d8
}

.cms-modal .cms-modal__footer label{
  margin-bottom:0px;
  -webkit-user-select:none;
          user-select:none
}

.compact .card-info{
  display:none
}

.card-content{
  position:absolute;
  top:0;
  right:0;
  left:0;
  bottom:0
}

.card-item{
  --text-opacity:1;
  color:#334155;
  color:rgba(51, 65, 85, var(--text-opacity))
}

.cards-ui-header{
  --bg-opacity:1;
  background-color:#94a3b8;
  background-color:rgba(148, 163, 184, var(--bg-opacity));
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  font-weight:600
}

.selected-card .cards-ui-header{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100, 116, 139, var(--bg-opacity));
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity))
}

.varsome_clinical .card-item.card-item-larger{
  height:75px
}

.card-item{
  height:68px;
  padding:8px
}

.card-item:hover{
  --text-opacity:1;
  color:#0f172a;
  color:rgba(15, 23, 42, var(--text-opacity))
}

.card-item *{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}

.compact .card-item{
  height:unset !important;
  padding:2px
}

.compact .card-item .icon{
  display:none
}

.compact .card-item .fa{
  display:none
}

.compact .card-item,.side-container .card-item{
  height:unset !important
}

.top-compact .card-item{
  min-height:30px;
  height:30px !important
}

.compact .card-item,.top-compact .card-item{
  height:unset !important
}

.compact .cards-ui-header,.top-compact .cards-ui-header{
  background-color:rgba(0,0,0,0) !important;
  font-weight:400;
  --text-opacity:1;
  color:#0f172a;
  color:rgba(15, 23, 42, var(--text-opacity))
}

.disabled-card .cards-ui-header{
  background-color:rgba(0,0,0,0) !important;
  color:#1e1e3c !important
}

.focusable-highlight-card{
  transition:background-color 150ms linear
}

:focus>.focusable-highlight-card{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226, 232, 240, var(--bg-opacity))
}

.selected-card{
  opacity:1
}

.selected-card .card-info{
  --text-opacity:1;
  color:#1e293b;
  color:rgba(30, 41, 59, var(--text-opacity))
}

.selected-card .card-info a{
  filter:brightness(90%)
}

.top-compact .card-info{
  display:none
}

.card-tooltip-content .hide-in-tooltip{
  display:none
}

.varsome-table-fixed thead tr{
  border-top:none
}

.varsome-table-fixed--borderBody tbody td{
  border:1px solid #e5e5e5
}

.varsome-table-fixed--autoWidth{
  table-layout:auto !important;
  width:auto !important
}

.abbr--custom{
  cursor:help;
  border-bottom:1px dotted currentColor
}

.varsome-table-minimum-padding td{
  padding:5px !important
}

.gnomad-cell,.gnomad-cell-female{
  background-color:#f5f5f5;
  text-align:right
}

.gnomad-cell-male{
  background-color:#f5f5f5;
  text-align:right;
  border-top:1px solid #3cdbc0
}

.gnomad-cell-freq-male{
  background-color:#f5f5f5;
  padding-left:95px !important;
  border-top:1px solid #3cdbc0
}

.gnomad-cell-freq,.gnomad-cell-freq-female{
  background-color:#f5f5f5;
  padding-left:95px !important
}`, "",{"version":3,"sources":["webpack://./src/scss/minimum-style.scss","webpack://./src/scss/_modal.scss","webpack://./src/scss/_default_tooltip.scss","<no source>","webpack://./src/scss/_variables.scss","webpack://./src/scss/_atomic.scss","webpack://./src/scss/_loader.scss","webpack://./src/scss/_icons.scss","webpack://./src/scss/_acmg.scss","webpack://./src/scss/_d3svg.scss","webpack://./src/scss/_gdpr-modal.scss","webpack://./src/scss/_heatmap.scss","webpack://./src/scss/_charts.scss","webpack://./src/scss/_tables.scss","webpack://./src/scss/atoms/_buttons.scss","webpack://./src/scss/atoms/_radiobutton.scss","webpack://./src/scss/atoms/_icons.scss","webpack://./src/scss/atoms/_helpers.scss","webpack://./src/scss/atoms/_pill.scss","webpack://./src/scss/_legend.scss","webpack://./src/scss/_publications.scss"],"names":[],"mappings":"AAAA;ECAA,SACE;EAAA,0CACA;EAAA,aACA;EAAA;AACA;;AAAA;EAEF,SACE;EAAA;AACA;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAGF,kBACE;EAAA,iBACA;EAAA;AACA;;AAAA;EACA;AACE;;AAAA;EAEF,8BACE;EAAA,wBACA;EAAA;AACA;;AAAA;EAEF,4BACE;EAAA,wBACA;EAAA;AACA;;AAAA;EAIJ,qBACE;EAAA,4CACA;EAAA;AACA;;AAAA;EAGF,oBACE;EAAA,wBACA;EAAA,4BACA;EAAA;AACA;;AAAA;EAGF,8CACE;EAAA,4BACA;EAAA;AACA;;AAAA;EAIA,4BACE;EAAA;AACA;;AAAA;EC7DJ,cACE;EAAA;AACA;;AAAA;EAGF,qBACE;EAAA;AACA;;AAAA;ECPF,iBAAA;EAAA,cAAA;EAAA,4CAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,iBAAA;EDYI;AEuBQ;;AAAA;EFrBR,UACE;EAAA;AACA;;AAAA;EChBN,iBAAA;EAAA,cAAA;EAAA,+CAAA;EAAA,oBAAA;EDoBI;AACA;;AAAA;EAKF,kCACE;UADF,0BACE;EAAA;AACA;;AAAA;EC5BJ,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;ADgCI;;AAAA;EChCJ,oBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,+CAAA;EDoCI,0BACA;EAAA;AACA;;AAAA;ECtCJ,mBAAA;EAAA,qBAAA;EAAA,wDAAA;EAAA;AD0CI;;AAAA;EAKF,kCACE;UADF,0BACE;EAAA;AACA;;AAAA;ECjDJ,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;ADqDI;;AAAA;ECrDJ,oBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,4CAAA;EDyDI,uBACA;EAAA;AACA;;AAAA;EC3DJ,iBAAA;EAAA,cAAA;EAAA;AD+DI;;AAAA;EC/DJ,mBAAA;EAAA,qBAAA;EAAA,wDAAA;EAAA;ADmEI;;AAAA;EAKF,kCACE;UADF,0BACE;EAAA;AACA;;AAAA;EC1EJ,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;AD8EI;;AAAA;EC9EJ,oBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,4CAAA;EDkFI,uBACA;EAAA;AACA;;AAAA;ECpFJ,iBAAA;EAAA,cAAA;EAAA;ADwFI;;AAAA;EAKF,kCACE;UADF,0BACE;EAAA;AACA;;AAAA;EC/FJ,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;ADmGI;;AAAA;ECnGJ,oBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,+CAAA;EDuGI,0BACA;EAAA;AACA;;AAAA;ECzGJ,mBAAA;EAAA,qBAAA;EAAA,wDAAA;EAAA;AD6GI;;AAAA;EAKF,kCACE;UADF,0BACE;EAAA;AACA;;AAAA;ECpHJ,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;ADwHI;;AAAA;ECxHJ,oBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,+CAAA;ED4HI,0BACA;EAAA;AACA;;AAAA;EC9HJ,mBAAA;EAAA,qBAAA;EAAA,wDAAA;EAAA;ADkII;;AAAA;EClIJ,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;ADwII;;AAAA;ECxIJ,oBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,+CAAA;ED4II,SACA;EAAA;AACA;;AAAA;EC9IJ,mBAAA;EAAA,qBAAA;EAAA,wDAAA;EAAA;ADkJI;;AAAA;EClJJ,aAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,wBAAA;EAAA,eAAA;EAAA;ADuJE;;AAAA;ECvJF,gBAAA;EAAA,kBAAA;EAAA;AD0JI;;AAAA;EC1JJ,aAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA;AD+JE;;AAAA;EC/JF,gBAAA;EAAA,iBAAA;EAAA;ADkKI;;AAAA;EGhKJ;AACE;;AAAA;EAGF,WACE;EAAA,WACA;EACA;AACA;;AAAA;EAGF,eACE;EACA;AACA;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;ADQY;;AAAA;ECJZ;AACE;;AAAA;EAIA;AAEE;;AAAA;EAKF;AAEE;;AAAA;EAIJ;AACE;;AAAA;EFlDF,iBAAA;EAAA;AEuDE;;AAAA;EAGF;AACE;;AAAA;EAGF,iCACE;UADF;AACE;;AAAA;EAGF,iCACE;UADF;AACE;;AAAA;EAGF,kCACE;UADF;AACE;;AAAA;EAGF;AAEE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF,SACE;EAAA;AACA;;AAAA;EAGF,kBAEE;EAAA,oBACA;EAAA;AACA;;AAAA;EAGF,SACE;EAAA;AACA;;AAAA;EAGF,kBACE;EAAA,oBACA;EAAA;AACA;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAIA;AACE;;AAAA;EAKF;AACE;;AAAA;EAIJ;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF,eACE;EAAA;AACA;;AAAA;EAGF,gBACE;EAAA;AACA;;AAAA;EAGF,eACE;EAAA;AACA;;AAAA;EAGF,eACE;EAAA;AACA;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAEF,cACE;EAAA;AACA;;ACxDM;EAGR;IACI,OACI;IAAA,QACA;IAAA,SACA;IAAA;EACA;;EAAA;IAEJ,SACI;IAAA,UACA;IAAA,oBACA;IAAA;EACA;;EAAA;IAEJ,SACI;IAAA,UACA;IAAA,oBACA;IAAA;EACA;AAAA;;AAAA;EAGR,eACI;EAAA,WACA;EAAA,YACA;EAAA;AACA;;AAAA;EACA,WACI;EAAA;AACA;;AAAA;EAGR,iBACI;EAAA,OACA;EAAA,QACA;EAAA,QACA;EAAA,OACA;EAAA,QACA;EAAA,SACA;EAAA,iBACA;EAAA,iBACA;EAAA,kBACA;EAIA;AACA;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ,oBF5LU;EEiMN;AACA;;AAAA;ECvMJ,2BACI;;EAAA,2KAEI;;EAAA,kBAGJ;;EAAA;AACA;;AAAA;EAGJ,sCAEI;EAAA,UACA;EAAA,iBACA;EAAA,kBACA;EAAA,mBACA;EAAA,mBACA;EAAA,aACA;EAAA,kCAGA;EAAA;AACA;;AAAA;EAGJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACI;;AAAA;EAEJ;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;ECtEF,cACE;EAAA;AACA;;AAAA;EAIA,oCACE;EAAA;AACA;;AAAA;EAEF,iBACE;EAAA,cACA;EAAA,0BACA;EAAA;AACA;;AAAA;EACA;AACE;;AAAA;EACA;AACE;;AAAA;EAGJ,cACE;EAAA;AACA;;AAAA;EACA;AACE;;AAAA;EAMR,4BACE;EAAA,+BACA;EAAA,2BACA;EAAA;AACA;;AAAA;EAGF;IACE,iBACE;IAAA;EACA;;EAAA;IAEF,iBACE;IAAA,eACA;IAAA,qBACA;IAAA,iBACA;IAAA,qBACA;IAAA,UACA;IAAA,cACA;IAAA,YACA;IAAA,uBACA;IAAA;EACA;;EAAA;IAEF,6CACE;IAAA,kBACA;IAAA,sBACA;IAAA,WACA;IAAA,oBACA;IAAA,QACA;IAAA,qBACA;IAAA;EACA;AAAA;;AAAA;EAIJ;IACE,iBACE;IAAA,cACA;IAAA,oBACA;IAAA;EACA;;EAAA;IAEF,iBACE;IAAA,eACA;IAAA,qBACA;IAAA,iBACA;IAAA,qBACA;IAAA,UACA;IAAA,cACA;IAAA,YACA;IAAA,wBACA;IAAA;EACA;;EAAA;IAEF,6CACE;IAAA,kBACA;IAAA,sBACA;IAAA,WACA;IAAA,aACA;IAAA,QACA;IAAA,qBACA;IAAA,iBACA;IAAA,UACA;IAAA,OACA;IAAA;EACA;AAAA;;AAAA;EAGJ;AACE;;AAAA;EAGF,6CACE;EAAA;AACA;;AAAA;EAGF;AAEE;;AAAA;EAGF;AACE;;AAAA;EAGF,qBACE;EAAA,qBACA;EAAA,eACA;EAAA,gBACA;EAAA,eACA;EAAA,iBACA;EAAA,QACA;EAAA,UACA;EAAA,UACA;EAAA;AACA;;AAAA;EAGF,gBACE;EAAA,UACA;EAAA,gBACA;EAAA;AACA;;AAAA;EAGF,qBACE;EAAA,uBACA;EAAA,cACA;EAAA,aACA;EAAA;AACA;;AAAA;EAGF,wBACE;EAAA;AACA;;AAAA;EAGF,wBACE;EAAA;AACA;;AAAA;EAGF,qBACE;EAAA,UACA;EAAA,cACA;EAAA,aACA;EAAA;AACA;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAIA,kBACE;EAAA,iBACA;EAAA,kBACA;EAAA,UACA;EAAA;AACA;;AAAA;EACA;AACE;;AAAA;EAKN;AAGE;;AAAA;EAEF;AAEE;;AAAA;EAEF,gBACE;EAAA;AACA;;AAAA;EAEE,wBJvNqB;EAAA;AASV;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAgOA,wBJ1NqB;EAAA;AASV;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAmOA,wBJ5NgB;EAAA;AAQL;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAsOA,wBJ9NkB;EAAA;AAOP;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAyOA,wBJhOoB;EAAA;AAMT;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EA8OA,wBJnOiB;EAAA;AAIN;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAiPA,wBJtOiB;EAAA;AAIN;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAoPA,wBJxOY;EAAA;AAGD;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EAuPA,wBJ1Oc;EAAA;AAEH;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EA0PA,wBJ5OgB;EAAA;AACL;;AAAA;EIrBb;AACE;;AAAA;EAGF,cACE;EAAA;AACA;;AAAA;EA8PF;AACE;;AAAA;EC3QJ;ALQO;;AAAA;EKJP;AACI;;AAAA;EACA;AACI;;AAAA;EAEJ;AACI;;AAAA;EACA;AACI;;AAAA;EAKZ;AACI;;AAAA;EACA;AACI;;AAAA;EAIR;AACI;;AAAA;EACA;AACI;;AAAA;EAIR;AACI;;AAAA;EACA;AACI;;AAAA;EClCR,4BACE;EAAA,cACA;EAAA;AACA;;AAAA;EAGF,+DACE;EAAA,cACA;EAAA,eACA;EAAA,aACA;EAAA;AACA;;AAAA;EAGF,QAIE;EAAA,mBACA;EAAA,YACA;EAAA;AACA;;AAAA;EAGF,oBACE;EAAA,oBACA;EAAA,iBACA;EAAA,eACA;EAAA,aACA;EAAA,aACA;EAAA,qBACA;EAAA;AACA;;AAAA;EAGF,aACE;EAAA,iBACA;EAAA,eACA;EAAA,WACA;EAAA,oBACA;EAAA,YACA;EAAA,cACA;EAAA;AACA;;AAAA;EACA;AACE;;AAAA;EAEF;AACE;;AAAA;EAIJ;AACE;;AAAA;EAGF;AACE;;AAAA;EAGF,6DACE;EAAA,wBACA;EAAA;AACA;;AAAA;EAEF,UACE;EAAA,YACA;EAAA,kBACA;EAAA,wBACA;EAAA,UACA;EAAA,oBACA;EAAA;AACA;;AAAA;EAGF,kBAGE;EAAA;AACA;;AAAA;EAKA;IATF;EAUI;AAAA;;AAAA;EAGF;IAbF;EAcI;AAAA;;AAAA;EAGF,wBAGE;EAAA;AACA;;AAAA;EAGF,wBACE;EAAA;AACA;;AAAA;EAKF;AACE;;AAAA;EAGF;IACE;EACE;AAAA;;AAAA;EAIJ;IACE;EACE;AAAA;;AAAA;EAIJ;IACE;EACE;AAAA;;AAAA;EAIJ;IACE;EACE;AAAA;;AAAA;EAIJ,uBACE;EAAA,oBACA;EAAA,qBACA;EAAA,UACA;EAAA,WACA;EAAA,cACA;EAAA;AACA;;AAAA;EAGF,iBACE;EAAA,UACA;EAAA,SACA;EAAA;AACA;;AAAA;EAGF,eACE;EAAA,gBACA;EAAA;AACA;;AAAA;EAGF;AACE;;AAAA;EAKF;AACE;;AAAA;EAGF,oBACE;EAAA,SACA;EAAA,oBACA;EAAA,iBACA;EAAA,eACA;EAAA,aACA;EAAA,UACA;EAAA;AACA;;AAAA;EAGF,wBACE;EAAA;AACA;;AAAA;EACA,iBACE;EAAA;AACA;;AAAA;EAIJ,qBAEE;EAAA,wBACA;EAAA;AACA;;AAAA;EACA;AACE;;AAAA;EAIJ,UAEE;EAAA,oBACA;EAAA;AACA;;AAAA;EACA,iBACE;EAAA;AACA;;AAAA;EAIJ,YACE;EAAA;AACA;;AAAA;EAGF;IACE,aACE;IAAA,qBACA;IAAA,UACA;IAAA;EACA;AAAA;;AAAA;EAIJ,UACE;EAAA,iBACA;EAAA,eACA;EAAA,wBACA;EAAA;AACA;;AAAA;EAGF;IACE;EACE;AAAA;;AAAA;ECvON,iEP+BU;EAAA;AO7BN;;AAAA;EAGJ,iEP0BU;EAAA;AOxBN;;AAAA;EAGJ,eACI;EAAA,cACA;EAAA;AACA;;AAAA;EAGJ,eACI;EAAA,cACA;EAAA;AACA;;AAAA;EAGJ,iEPSU;EAAA;AOPN;;AAAA;EAGJ,eACI;EAAA,cACA;EAAA;AACA;;AAAA;EAGJ;AACI;;AAAA;EAGJ;AACI;;AAAA;EAGJ,cACI;EAAA;AACA;;AAAA;EAGJ,eACI;EAAA,YACA;EAAA,mCACA;EAAA,YACA;EAAA,eACA;EAAA,UACA;EAAA,iBACA;EAAA,cACA;EAAA,YACA;EAAA;AACA;;AAAA;ECzDJ,YACE;EAAA;AACA;;AAAA;EAGF,aACE;EAAA,qBACA;EAAA,WACA;EAAA,iBACA;EAAA,gBACA;EAAA,iBACA;EAAA;AACA;;AAAA;EACA,UACE;EAAA,WACA;EAAA,mBACA;EAAA,SACA;EAAA,MACA;EAAA;AACA;;AAAA;EACA,UACE;EAAA,WACA;EAAA,YACA;EAAA;AACA;;AAAA;EAGJ;IAtBF;EAuBI;;EAAA;IACA;EACE;AAAA;;AAAA;EAGJ;IA5BF,YA6BI;IAAA,iBACA;IAAA;EACA;;EAAA;IACA;EACE;;EAAA;IAEF,gBACE;IAAA;EACA;AAAA;;AAAA;EAIJ,UACE;EAAA,WACA;EAAA;AACA;;AAAA;EAEF,UACE;EAAA;AACA;;AAAA;EAEF,WAIE;EAAA,YACA;EAAA,YACA;EAAA,sBACA;EAAA,qBACA;EAAA,wBACA;EAAA,cACA;EAAA,iBACA;EAAA;AACA;;AAAA;EAXA;AACE;;AAAA;EAWF,gBACE;EAAA,YACA;EAAA,sBACA;EAAA;AACA;;AAAA;EAGF,kBACE;EAAA;AACA;;AAAA;EAEF,eACE;EAAA;AACA;;AAAA;EAGJ,WAIE;EAAA,YACA;EAAA,YACA;EAAA,sBACA;EAAA,qBACA;EAAA,wBACA;EAAA,cACA;EAAA,iBACA;EAAA;AACA;;AAAA;EAXA;AACE;;AAAA;EAWF,gBACE;EAAA,YACA;EAAA,sBACA;EAAA;AACA;;AAAA;EAGF,kBACE;EAAA;AACA;;AAAA;EAEF,eACE;EAAA;AACA;;AAAA;EAIN;AACE;;AAAA;EClHA;AACE;;AAAA;EAIJ,wBACE;EAAA,eACA;EAAA,aACA;EAAA;AACA;;AAAA;EACA;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF,qBAEE;EAAA,YACA;EAAA;AACA;;AAAA;EAEF;AACE;;AAAA;EAGA,kBACE;EAAA,aACA;EAAA,iBACA;EAAA,iBACA;EAAA,+BACA;EAAA;AACA;;AAAA;EAGJ;AACE;;AAAA;EACA;AACE;;AAAA;EACA;AACE;;AAAA;EAIN,gBACE;EAAA,QACA;EAAA;AACA;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAGA;AACE;;AAAA;EAIF;AACE;;AAAA;EAKA;AACE;;AAAA;EAIN;AACE;;AAAA;EAGA;AACE;;AAAA;EAMJ;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF;AACE;;AAAA;EAEF,QACE;EAAA;AACA;;AAAA;EAEF,uBACE;EADF,eACE;EAAA,SACA;EAAA,SACA;EAAA;AACA;;AAAA;EVxGJ,qBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,qBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,uDAAA;EAAA,eAAA;EAAA,yBAAA;EAAA,uDAAA;EAAA,iBAAA;EAAA,WAAA;EAAA;AWCE;;AAiBF;EXlBA,eAAA;EAAA,yBAAA;EAAA,uDAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;AWmBE;;AAIF;EXvBA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,wDAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA;AWwBE;;AAcF;EXtCA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,8CAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;AWuCE;;AAaF;EXpDA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,8CAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;AWqDE;;AAcF;EXnEA,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,eAAA;EAAA,yBAAA;EAAA;AWoEE;;AAIF;EXxEA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;AWyEE;;AAWF;EXpFA,iBAAA;EAAA,kBAAA;EAAA;AWqFE;;AAKF;EAEE,kBAAA;EACA;AAAA;;ACvFF;EACE,kCAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEE;EACE;AAAA;;AAGJ;EACE;AAAA;;AACA;EACE,oBAnBiB;EAoBjB;AAAA;;AAGF;EACE;AAAA;;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,wBAAA;UAAA;AAAA;;AAEF;EACE;AAAA;;AAKN;EACE,oBAAA;EACA,WAtCU;EAuCV,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA;AAAA;;AAEA;EAEE,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,uBAAA;EACA;AAAA;;AAGF;EACE,MAAA;EACA,KAAA;EACA,UAzDQ;EA0DR,WA1DQ;EA2DR;AAAA;;AAGF;EACE,yBAAA;EACA,0BAAA;EACA,UAhEgB;EAiEhB,WAjEgB;EAkEhB,kBAAA;EACA;AAtEiB;;AA0ErB;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;UAAA;AAAA;;AAGJ;EACE,mBAAA;EACA,cAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAIF;EACE;AAAA;;AACA;EACE,WAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,OAAA;EACA,QAAA;EACA,SAAA;EACA;AAAA;;AAOV;EACE;IACE;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;AAAA;;AC1HJ;EACE,UAAA;EACA,WAAA;EACA;AAAA;;ACHF;EACE,0BAAA;EACE,wBAAA;EAIQ;AAAA;;ACNZ;EACE,eAAA;EfDF,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA;AeGE;;AASF;EACE;AAAA;;ACXM;EACI,cAAA;EACA,iBAAA;EACA;AAAA;;AAGR;EACI,iBAAA;EACA;AAAA;;AACA;EACI,eAAA;EACA;AfoBJ;;AehBA;EACI;AAAA;;AChBR;EACE,gBAAA;EACA,cAAA;EACA;AAAA;;AAKF;EACE;AAAA;;AAIJ;EACE,eAAA;EACA,cAAA;EACA;AAAA;;AAGF;EACE,cAAA;EACA;AAAA;;AAKA;EjB5BJ,iBAAA;EAAA;AiB6BM;;AAIJ;EACE,eAAA;EACA,aAAA;EACA;AAAA;;AAKF;EjBzCF,sEAAA;EAAA,8CAAA;EAAA,oGAAA;EAAA,yBAAA;EAAA;AiB0CI;;AAGF;EjB7CF,yEAAA;EAAA,8CAAA;EAAA,oGAAA;EAAA,yBAAA;EAAA;AiB8CI;;AAGF;EjBjDF,wEAAA;EAAA,yBAAA;EAAA,8CAAA;EAAA,oGAAA;EAAA;AiBkDI;;AAIJ;EjBtDA,yEAAA;EAAA,yBAAA;EAAA,8CAAA;EAAA;AiBuDE;;ApBvCF;EAIE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA;AAAA;;AAGF;EACE;IACE;EAAA;AAAA;;AAIJ;EACE,iEIDQ;EJER,UAAA;EACA,aAAA;EACA;AAAA;;AAEE;EACE,aAAA;EACA;AAAA;;AACA;EACE,aAAA;EACA,cAAA;EACA;AIzCE;;AJ2CJ;EACE,aIvCD;EJwCC,gBAAA;EACA;AAAA;;AAKR;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,wBIpDO;EJqDP,UAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,gBAAA;EACA;AAAA;;AAKN;EACE,iBAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA,eAAA;EACA;AAAA;;AAEF;EACE,iBAAA;EACA,OAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAKN;EACE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA;AAAA;;AACA;EACE,+BAAA;EACA,UAAA;EACA;AAAA;;AAEF;EAEE,+BAAA;EACA;AAAA;;AAEF;EACE;AI9GM;;AJmHR;EACE;AAAA;;AAIJ;EACE,cAAA;EACA;AAAA;;AACA;EACE,cAAA;EACA,mCAAA;UAAA;AAAA;;AAEF;EACE;AAAA;;AAIJ;EACE,wBAAA;EACA;AAAA;;AACA;EACE,cAAA;EACA,KAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA;AAAA;;AAGA;EACE,qBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAKR;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,qCAAA;EACA,qBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAIF;EACE,kBAAA;EACA,kBAAA;EACA;AAAA;;AAIJ;EACE,wBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE,iBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AIvMQ;;AJyMV;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEE;EACE;AAAA;;AAIN;EAEE,UAAA;EACA,gBAAA;EACA;AAAA;;AACA;EACE;AIvMe;;AJyMjB;EACE,YAAA;EACA,gBAAA;EACA,+DIzMI;EJ0MJ;AAAA;;AAEF;EACE,YAAA;EACA,+DI9MI;EJ+MJ;AAAA;;AACA;EAGE,+DInNE;EJoNF;AAAA;;AAEF;EACE;AIxNI;;AJ2NR;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE,gBAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAIF;EACE,qBAAA;EACA;AAAA;;AAIF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAIJ;EACE,qBAAA;EACA,cAAA;EACA,0BAAA;EACA,+BAAA;EACA,0BAAA;EACA,oBAAA;EACA,wBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAIJ;EACE,yBAAA;EACA;AAAA;;AAGF;EACE,yBAAA;EACA,cAAA;EACA;AAAA;;AAGF;EACE,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE,+DI7RI;EJ8RJ;AAAA;;AAEF;EACE,+DIjSI;EJkSJ;AAAA;;AAEF;EACE;AAAA;;AAIJ;EACE,YAAA;EACA,kBAAA;EACA;AAAA;;AAEF;EACE,YAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,eAAA;EACA;AI7UW;;AJ+Ub;EACE,aAAA;EACA;AAAA;;AAME;EACE,yBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAQF;EACE;AAAA;;AAKN;EAEE,wEIlVO;EJmVP,qBAAA;EACA,aIhXK;EJiXL;AAAA;;AAEA;EACE,aIzXM;EJ0XN,oBAAA;EACA;AAAA;;AACA;EACE,yBAAA;EACA;AAAA;;AAEF;EACE,aIhYM;EJiYN;AAAA;;AAEF;EAGE,aIvYI;EJwYJ;AAAA;;AAIJ;EACE,wBAAA;EACA,UAAA;EACA,sCAAA;EACA;AAAA;;AAEF;EACE,4BAAA;EACA,qBAAA;EACA;AAAA;;AACA;EACE,8BAAA;EACA,WAAA;EACA;AAAA;;AAIJ;EACE,aAAA;EACA,UAAA;EACA,wBIjaO;EJkaP,iCIpaK;EJqaL,cAAA;EACA,oCAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA;AAAA;;AAIJ;EACE,wBAAA;EACA,uBAAA;EACA;AAAA;;AAGF;EACE,gBAAA;EACA,oBAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA;AAAA;;AAIJ;EACE,qBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AACA;EACE,WAAA;EACA,UAAA;EACA,eAAA;EACA;AAAA;;AAIN;EACE,wBAAA;EACA;AAAA;;AAGF;EACE,qBAAA;EACA,eAAA;EACA,8BIndK;EJodL,iBAAA;EACA,YAAA;EACA,gBAAA;EACA;AAAA;;AACA;EACE;AIvbG;;AJybL;EACE,kBAAA;EACA,aIpdO;EJqdP,gBAAA;EACA,iBAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE,gBAAA;EACA;AAAA;;AAGJ;EACE,cAAA;EACA;AAAA;;AAEF;EACE,aAAA;EACA,gBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE;AIveA;;AJ0eJ;EACE,aAAA;EACA;AAAA;;AAGJ;EACE,8BI5fK;EJ6fL;AAAA;;AACA;EACE,aItfO;EJufP;AAAA;;AAEF;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA;AAAA;;AAEA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA;AAAA;;AACA;EACE,oBAAA;EACA,aIvgBG;EJwgBH;AI/eD;;AJkfH;EAEE;AAAA;;AAEF;EACE;AAAA;;AACA;EACE,aIxhBA;EJyhBA;AAAA;;AAEF;EACE;AInhBF;;AJyhBN;EACE;AAAA;;AAGF;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AACA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,qBAAA;EACA;AAAA;;AACA;EACE,qBAAA;EACA;AAAA;;AAEF;EACE,4BAAA;EACA,eAAA;EACA;AIxjBD;;AJyjBC;EACE;AAAA;;AAIN;EACE;AAAA;;AAGJ;EACE,YAAA;EACA,qBAAA;EACA,wBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AAEE;EACE;AAAA;;AAGJ;EACE;AAAA;;AAIJ;EACE;AAAA;;AACA;EACE,oBAAA;EACA,UAAA;EACA,aAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAIJ;EACE,QAAA;EACA,kBAAA;EACA,gCAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAGA;EACE,+DInlBA;EJolBA,cAAA;EACA;AI7mBK;;AJ+mBP;EACE;AIpnBE;;AJunBN;EACE;AAAA;;AAKF;EACE;AAAA;;AAEF;EACE;AAAA;;AAIJ;EACE,wBIloBS;EJmoBT,UAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AACA;EACE,oBAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,oBAAA;EACA;AAAA;;AAIJ;EACE,kBAAA;EACA;AInqBK;;AJqqBH;EACE,+DIroBA;EJsoBA,cAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAGJ;EACE;AAAA;;AAIN;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA;AItrBK;;AJ0rBT;EACE;AAAA;;AACA;EACE;AAAA;;AAIJ;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,cAAA;EACA,cAAA;EACA;AAAA;;AAGF;EACE,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,yBAAA;EACA,6BAAA;EACA,yBAAA;EACA,wBAAA;EACA,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mCAAA;UAAA,2BAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AACA;EACE,qBAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA;AAAA;;AACA;EACE,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA;AAAA;;AAMJ;EACE;AAAA;;AACA;EACE,qBAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA;AAAA;;AACA;EACE,qBAAA;EACA,+BAAA;EACA,wBAAA;EACA;AAAA;;AAIN;EAEE,wBAAA;EACA;AAAA;;AAEF;EACE,wBAAA;EACA;AAAA;;AAGJ;EAEE,wBAAA;EACA;AAAA;;AAEF;EAEE;AAAA;;AAEF;EAIE,wBAAA;EACA;AAAA;;AAIA;EAGE;AAAA;;AAOF;EACE;AAAA;;AAGF;EAEE,aAAA;EACA;AAAA;;AAIJ;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAIA;EACE;AAAA;;AAIJ;EACE;AAAA;;AAGF;EACE;AAAA;;AAIA;EACE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE;AAAA;;AAKF;EACE;AAAA;;AAGF;EACE,cAAA;EACA,cAAA;EACA,qBAAA;EACA;AAAA;;AAGF;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA;AAAA;;AAGF;EACE,qCAAA;EACA;AAAA;;AAGJ;EACE;AAAA;;AAEF;EACE,oBAAA;EACA;AAAA;;AAKA;EACE;AAAA;;AACA;EACE,gBAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,aAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,UAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAKJ;EAEE,aAAA;EACA;AAAA;;AAGJ;EACE;AAAA;;AAEF;EACE;AAAA;;AAMJ;EACE,iBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA;AAAA;;AAGF;EACE,oBAAA;EACA;AIn5BM;;AJs5BR;EACE;AIv5BM;;AJy5BR;EACE;AI35BQ;;AJi6BR;EACE,iBAAA;EACA;AAAA;;AAIJ;EACE;AAAA;;AAIA;EACE;AAAA;;AAIJ;EACE,eAAA;EACA,iBAAA;EACA;AAAA;;AAGF;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA;AAAA;;AAGF;EACE,eAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA;AAAA;;AAIA;EACE;AAAA;;AACA;EACE;AAAA;;AAGJ;EACE;AAAA;;AAGA;EACE;AAAA;;AAGJ;EACE,iBAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA,wBAAA;UAAA;AAAA;;AAKN;EACE;AAAA;;AAGF;EACE,iBAAA;EACA,KAAA;EACA,OAAA;EACA,MAAA;EACA;AAAA;;AAGF;EGjhCA,iBAAA;EAAA,cAAA;EAAA;AHkhCE;;AAGF;EGrhCA,eAAA;EAAA,yBAAA;EAAA,wDAAA;EAAA,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA;AHshCE;;AAIA;EG1hCF,eAAA;EAAA,yBAAA;EAAA,wDAAA;EAAA,iBAAA;EAAA,WAAA;EAAA;AH2hCI;;AAKF;EACE;AAAA;;AAIJ;EACE,WAAA;EGtiCF;AHuiCE;;AACA;EGxiCF,iBAAA;EAAA,cAAA;EAAA;AHyiCI;;AAEF;EACE,eAAA;EACA,sBAAA;EACA;AAAA;;AAIJ;EACE,uBAAA;EGnjCF;AHojCE;;AACA;EACE;AAAA;;AAEF;EACE;AAAA;;AAIJ;EAEE;AAAA;;AAGF;EACE,eAAA;EACA;AAAA;;AAKA;EACE;AAAA;;AAEF;EACE,yCAAA;EG7kCJ,gBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA;AH8kCI;;AAKF;EACE,yCAAA;EACA;AAAA;;AAIJ;EACE;AAAA;;AAGF;EG7lCA,eAAA;EAAA,yBAAA;EAAA;AH8lCE;;AAGF;EACE;AAAA;;AACA;EGnmCF,iBAAA;EAAA,cAAA;EAAA;AHumCI;;AAHA;EACE;AAAA;;AAOJ;EACE;AAAA;;AAKF;EACE;AAAA;;AAKF;EACE;AAAA;;AAGA;EACE;AAAA;;AAGJ;EACE,4BAAA;EACA;AAAA;;AAIJ;EACE,WAAA;EACA;AAAA;;AAGA;EACE;AAAA;;AAGJ;EAEE,wBAAA;EACA;AAAA;;AAEF;EACE,wBAAA;EACA,gBAAA;EACA;AAAA;;AAEF;EACE,wBAAA;EACA,4BAAA;EACA;AAAA;;AAEF;EAEE,wBAAA;EACA;AAAA","sourcesContent":["@import \"variables\";\n@import \"modal\";\n@import \"default_tooltip\";\n@import \"atomic\";\n@import \"loader\";\n@import \"icons\";\n@import \"acmg\";\n@import \"d3svg\";\n@import \"gdpr-modal\";\n@import \"heatmap\";\n@import \"charts\";\n@import \"tables\";\n@import \"atoms/atoms\";\n@import \"legend\";\n@import \"publications\";\n\n*,\n::before,\n::after {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: #d4d4d8; /* 2 */\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1340px !important;\n  }\n}\n\n.varsome-request-container {\n  font-family: $raleway;\n  width: 100%;\n  margin: 0 auto;\n  text-align: center;\n  .varsome-variant-chooser {\n    .varsome-variant-option {\n      margin: 1rem 0;\n      margin-left: 0.8rem;\n      a {\n        padding: 0.5rem;\n        cursor: pointer;\n        color: $primary;\n      }\n      a.selected {\n        color: $text;\n        font-weight: bold;\n        background-color: #e5e5e5;\n      }\n    }\n  }\n}\n.varsome-request-error {\n  width: 100%;\n  margin: 10% 0;\n  padding: 1rem 0;\n  background-color: $danger;\n  color: #fff;\n  white-space: pre-line;\n  a {\n    color: white;\n    font-weight: bold;\n    &:hover {\n      color: white;\n      font-weight: bold;\n      text-decoration: underline;\n    }\n  }\n}\n\n.varsome-collapse-arrow {\n  position: relative;\n  text-align: center;\n  span {\n    position: absolute;\n    font-size: 0.5rem;\n    top: 0;\n  }\n  i {\n    position: absolute;\n    top: 6px;\n    left: 4px;\n    &.open {\n      left: 3px;\n    }\n  }\n}\n\n.btn-action {\n  font-size: 1rem;\n  cursor: pointer;\n  margin-right: 1rem;\n  color: #ddd;\n  padding: 0.25rem 1rem;\n  border: 2px solid #ddd;\n  font-weight: normal;\n  border-radius: 3px;\n  margin-top: 5px;\n  display: inline-block;\n  vertical-align: middle;\n  &:hover {\n    text-decoration: none !important;\n    color: white;\n    border: 2px solid white;\n  }\n  &:visited,\n  &:focus {\n    text-decoration: none !important;\n    color: #ddd;\n  }\n  &.active {\n    background-color: $primary;\n  }\n}\n\n.links {\n  &:visited {\n    color: #2ca591 !important;\n  }\n}\n\n.varsome-genome-browser {\n  user-drag: none;\n  background-color: #fff;\n  text {\n    user-drag: none;\n    user-select: none !important;\n  }\n  .nearby-variant {\n    cursor: pointer;\n  }\n}\n\n.varsome-genome-browser-container {\n  background-color: #f5f5f5;\n  position: relative;\n  &.full {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10000;\n    background-color: #fff;\n  }\n  .varsome-browser-controls {\n    .btn-action {\n      background-color: #fff;\n      margin-top: -0.3rem;\n      &:hover {\n        border: 2px solid #bbb;\n      }\n    }\n  }\n}\n.varsome-genome-browser-legend {\n  padding: 0.2rem 0.5rem;\n  position: absolute;\n  right: 0.5rem;\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid #ddd;\n  z-index: 1;\n}\n\n.varsome-citations {\n  font-size: 0.8rem;\n  padding: 1rem 2rem 0 1rem;\n  p {\n    color: $text-muted !important;\n  }\n}\n.dbnsfp-row {\n  td {\n    padding: 1rem 0.5rem;\n    vertical-align: top;\n    text-align: left;\n  }\n}\n\n.varsome-tooltip {\n  z-index: 10002 !important;\n  text-align: center;\n}\n\n.varsome-left {\n  float: left;\n}\n.varsome-right {\n  float: right;\n}\n.varsome-clearfix:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0;\n}\n.varsome-hidden {\n  display: none;\n}\n.varsome-bg-success {\n  background-color: $success;\n}\n.varsome-text-muted {\n  color: $text-muted !important;\n}\n.varsome-text-success {\n  color: $success !important;\n}\n.varsome-text-center {\n  text-align: center;\n}\n.varsome-table {\n  table-layout: fixed;\n  tr {\n    &.highlight td {\n      background-color: white;\n    }\n  }\n}\n.varsome-table,\n.varsome-table-overflow {\n  width: 100%;\n  border-spacing: 0;\n  border-collapse: collapse;\n  tr {\n    border-top: $table-top-border;\n  }\n  th {\n    padding: 10px;\n    font-weight: bold;\n    font-family: $cabin;\n    border-bottom: 1px solid $success;\n  }\n  td {\n    padding: 10px;\n    font-family: $cabin;\n    word-wrap: break-word;\n    span,\n    a,\n    div {\n      font-family: $cabin;\n      word-wrap: break-word;\n    }\n    .varsome-dbnsfp-label {\n      font-family: $raleway;\n    }\n  }\n  tr.varsome-bg-success td {\n    color: white;\n  }\n  tr.varsome-table-totals.gnomad-font-normal {\n    font-weight: normal;\n  }\n  tr.varsome-table-totals {\n    font-weight: bold;\n    border-top: 1px solid $success;\n  }\n  .gnomad-af-td-padding {\n    padding-left: 95px;\n  }\n  .varsome-cell-total {\n    font-weight: bold;\n  }\n}\n.varsome-pubmed-table-row {\n  &:hover {\n    background-color: #eee;\n    cursor: pointer;\n  }\n}\n.varsome-gene-stats-table {\n  tr {\n    border-top: 2px solid #999;\n  }\n  tr.varsome-table-totals {\n    border-top: 2px solid $success;\n  }\n  .fade-row td {\n    color: #ccc;\n  }\n}\n\n.varsome-gene-link {\n  color: white !important;\n  font-size: 12px;\n  font-weight: 600 !important;\n  text-decoration: none !important;\n  margin: 0.5rem 0.8rem 0.5rem 0;\n  padding: 0.25rem 0.5rem;\n  background-color: #40bbea;\n  display: inline-block;\n  &:hover {\n    background-color: #3396ba;\n  }\n}\n\n.varsome-truncated-seq {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.truncated-text{\n  text-decoration: underline;\n  cursor: pointer;\n  color: #373a3c;\n}\n\n.varsome-pubmed-article-short {\n  padding: 0.4rem 0.75rem;\n  border: 1px solid #ccc;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  position: relative;\n  h6 {\n    font-family: $cabin;\n    font-size: 1.2rem;\n  }\n  h4 {\n    font-family: $cabin;\n    font-size: 1.2rem;\n  }\n  p {\n    margin-bottom: 0.4rem;\n  }\n}\n\n.varsome-horiz-flex {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.varsome-horiz-list-item {\n  padding: 15px;\n  flex-grow: 1;\n  text-align: center;\n}\n.varsome-horiz-list-label {\n  font-size: 0.8rem;\n  color: $text-muted;\n}\n.varsome-expander {\n  display: block;\n  cursor: pointer;\n}\n\n.embeded-genes {\n  .varsome-result,\n  .varsome-result-fixed {\n    .varsome-container {\n      border: 0.1px solid #e5e5e5;\n      border-top: 1px solid #e5e5e5;\n    }\n\n    .varsome-title {\n      border-bottom: 1px solid #e5e5e5;\n    }\n  }\n}\n\n.genes-page {\n  .varsome-result,\n  .varsome-result-fixed {\n    .varsome-container {\n      border: 1px solid #e5e5e5;\n    }\n  }\n}\n\n.varsome-result,\n.varsome-result-fixed {\n  font-family: $roboto;\n  box-sizing: border-box;\n  color: $text;\n  line-height: 1.5;\n\n  a {\n    color: $primary;\n    text-decoration: none;\n    cursor: pointer;\n    &.varsome-white-link {\n      text-decoration: underline;\n      color: #fff;\n    }\n    &:hover {\n      color: $primary-h;\n      text-decoration: underline;\n    }\n    span,\n    small,\n    i {\n      color: $primary;\n      text-decoration: none;\n    }\n  }\n\n  .varsome-container {\n    border: 1px solid #e5e5e5;\n    width: 100%;\n    margin: 0 auto 0.9375rem auto !important;\n    background-color: #fff;\n  }\n  .varsome-container.varsome-container__basic {\n    margin-bottom: 0px !important;\n    background-color: white;\n    border: none !important;\n    .varsome-title {\n      background-color: transparent;\n      border: none;\n      border-bottom: 1px solid #e5e5e5;\n    }\n  }\n\n  .varsome-title {\n    display: block;\n    width: 100%;\n    background-color: $bg-title;\n    border-bottom: $border;\n    font-size: 1rem;\n    padding: 0.75rem 2.5rem 0.75rem 1.25rem;\n    position: relative;\n    small {\n      margin-left: 0.5rem;\n      font-size: 0.8rem;\n    }\n  }\n\n  .varsome-genes-title {\n    margin: 0 0 1.25rem -1rem;\n    width: calc(100% + 2rem);\n    border-top: 1px solid rgb(229, 229, 229);\n  }\n\n  .varsome-subtitle {\n    font-size: 1.5rem;\n    margin-bottom: 0.75rem;\n    font-weight: 300;\n    small {\n      margin-left: 0.5rem;\n      font-size: 0.8rem;\n    }\n  }\n\n  .varsome-inner-container {\n    background-color: #fff;\n    padding: 1.25rem;\n    .premium-badge-container {\n      display: none;\n      img {\n        height: 14px;\n        width: auto;\n        margin-left: 4px;\n        display: inline-block;\n      }\n    }\n  }\n  .varsome-subcontainer {\n    padding: 0 1rem 1rem 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .varsome-sequence-container {\n    background-color: #fff;\n    padding: 1.25rem;\n    border-top: $border;\n    text-align: center;\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: center;\n    * {\n      font-family: $cutive;\n    }\n    .varsome-sequence-small {\n      vertical-align: top;\n      color: $text-muted;\n      font-size: 1.5rem;\n      margin-top: 4.5rem;\n      overflow: hidden;\n      flex: 1 0;\n      &.before {\n        text-align: right;\n        direction: rtl;\n      }\n    }\n    .varsome-sequence-large {\n      font-size: 3rem;\n      margin: 0 1rem;\n    }\n    .val-text {\n      color: inherit;\n      line-height: 3rem;\n      margin-top: -0.7rem;\n      &.red span {\n        color: #c19999;\n      }\n      &.green span {\n        color: $green;\n      }\n    }\n    .pos-text {\n      color: inherit;\n      font-size: 0.75rem;\n    }\n  }\n  .varsome-equivalent-indels {\n    border-top: $border;\n    text-align: center;\n    .varsome-small-subtitle {\n      color: $text-muted;\n      margin-bottom: 1rem;\n    }\n    .varsome-equivalent-indel {\n      overflow: hidden;\n      display: flex;\n      flex-wrap: nowrap;\n      justify-content: center;\n\n      .indel-seq-container {\n        max-width: 60%;\n        overflow: hidden;\n        display: flex;\n        flex-wrap: nowrap;\n        justify-content: center;\n        * {\n          display: inline-block;\n          color: $text-muted;\n          font-family: $cutive;\n        }\n      }\n      .before-highlight,\n      .after-highlight {\n        color: orange;\n      }\n      .middle {\n        display: inline-block;\n        &.deletion * {\n          color: $primary;\n          text-decoration: line-through;\n        }\n        &.insertion * {\n          color: $green;\n        }\n      }\n    }\n  }\n\n  .varsome-genes-container {\n    background-color: #fafafa;\n  }\n\n  .varsome-tabs {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    position: relative;\n  }\n  .varsome-tab {\n    float: left;\n    a {\n      display: block;\n      padding: 0.5rem 1rem;\n      cursor: pointer;\n      text-decoration: none;\n      border: 1px solid #e5e5e5;\n      background-color: #fff;\n      z-index: 2;\n      &:hover {\n        background-color: #ccc;\n        color: #fff;\n      }\n      &.selected {\n        border-bottom: 1px solid #fff;\n        font-weight: 600;\n        color: $text;\n        &:hover {\n          background-color: #fff;\n        }\n      }\n    }\n    &:not(:first-child) {\n      margin-left: 1rem;\n    }\n  }\n  .varsome-tab-container {\n    padding: 0rem;\n    background-color: #fff;\n    border: 1px solid #e5e5e5;\n    margin-top: -1px;\n  }\n\n  .varsome-canonical-row {\n    background-color: #eee;\n    a {\n      &:hover {\n        color: #ccc;\n      }\n    }\n    span {\n      color: white;\n    }\n  }\n\n  .varsome-legend {\n    margin-top: 0.5rem;\n    .varsome-canonical-box {\n      display: inline-block;\n      width: 3rem;\n      height: 1.2rem;\n      background-color: #eee;\n    }\n    span {\n      vertical-align: middle;\n    }\n  }\n\n  .varsome-blockquote {\n    margin: 0;\n    padding: 0.5rem 1rem;\n    border-left: 0.25rem solid rgb(236, 238, 239);\n    margin-bottom: 1rem;\n    a {\n      font-size: 1.25rem;\n    }\n    footer {\n      * {\n        font-family: $cabin;\n        font-size: 1rem;\n        color: $text-muted;\n      }\n      a {\n        color: $success;\n      }\n    }\n    cite {\n      margin-left: 1rem;\n    }\n  }\n\n  .aact-blockquote {\n    a {\n      font-size: 1rem;\n    }\n    footer * {\n      font-size: 0.85rem;\n    }\n  }\n\n  .varsome-label {\n    background-color: $text-muted;\n    color: #fff;\n    font-size: 75%;\n    padding: 0.25rem 0.4rem;\n    font-weight: 700;\n    line-height: 1;\n    margin: 0 0 0 0.5rem;\n  }\n\n  .varsome-drug-list-item {\n    font-size: 1rem;\n    a {\n      display: inline-block;\n      word-break: break-all;\n    }\n    .varsome-label {\n      margin-top: 1px;\n      display: inline-block;\n      word-break: keep-all;\n    }\n  }\n\n  .varsome-comment-container {\n    margin-bottom: 1rem;\n    border-bottom: $border;\n    .varsome-comment {\n      p.varsome-comment-text {\n        font-family: $cabin;\n        font-size: 1rem;\n        white-space: pre-wrap;\n        a {\n          font-size: 1rem;\n        }\n      }\n      cite {\n        margin-left: 0.4rem;\n      }\n    }\n  }\n  .varsome-dl-horizontal {\n    margin-left: 0;\n    margin-right: 0;\n    padding-top: 1rem;\n    border: $border;\n  }\n}\n\n.varsome-inline-label {\n  margin-right: 1rem;\n  input {\n    margin-right: 0.25rem;\n  }\n}\n\n.form-check-label {\n  cursor: pointer;\n}\n\n.ReactModal__Body--open {\n  overflow: hidden;\n}\n\n.varsome-acmg-link {\n  font-size: 1rem;\n  cursor: pointer;\n  color: #2ca591;\n}\n\n.varsome-acmg-options {\n  display: inline-block !important;\n  padding: 0.375rem 1rem !important;\n  margin-right: 0.5rem !important;\n  font-size: 1rem !important;\n  white-space: nowrap !important;\n  cursor: pointer !important;\n  color: #2ca591 !important;\n  background-color: #ffffff !important;\n  border-radius: 2px !important;\n  line-height: 1.25 !important;\n  text-align: center !important;\n  user-select: none !important;\n  border: 1px solid #2ca591 !important;\n}\n.varsome-connect-button {\n  text-align: center;\n  a {\n    color: #ffffff !important;\n    background-color: #2ca591;\n    border-color: #2ca591;\n    padding: 0.5rem 1rem;\n    line-height: 1.25;\n    &:hover {\n      color: #ffffff !important;\n      text-decoration: none;\n      background-color: #217d6e;\n      border-color: #1f7567;\n    }\n  }\n}\n.varsome-result,\n.varsome-result-fixed {\n  .varsome-connect-button {\n    text-align: center;\n    a:not([href]):not([tabindex]) {\n      color: #ffffff !important;\n      background-color: #2ca591;\n      border-color: #2ca591;\n      padding: 0.5rem 1rem;\n      line-height: 1.25;\n      &:hover {\n        color: #ffffff !important;\n        text-decoration: none !important;\n        background-color: #217d6e;\n        border-color: #1f7567;\n      }\n    }\n  }\n  a.close-btn:not([href]):not([tabindex]):focus,\n  a.close-btn:not([href]):not([tabindex]):hover {\n    color: #1c695c !important;\n    text-decoration: none !important;\n  }\n  a:not([href]):not([tabindex]):hover {\n    color: #3cdbc0 !important;\n    text-decoration: underline !important;\n  }\n}\na.close-btn:not([href]):not([tabindex]):focus,\na.close-btn:not([href]):not([tabindex]):hover {\n  color: #1c695c !important;\n  text-decoration: none !important;\n}\na.btn-action:not([href]):not([tabindex]):focus,\na.btn-action:not([href]):not([tabindex]):hover {\n  text-decoration: none !important;\n}\n.varsome-result .varsome-table a:not([href]):not([tabindex]):hover,\n.varsome-result .varsome-clearfix a:not([href]):not([tabindex]):hover,\n.varsome-result-fixed .varsome-table a:not([href]):not([tabindex]):hover,\n.varsome-result-fixed .varsome-clearfix a:not([href]):not([tabindex]):hover {\n  color: #3cdbc0 !important;\n  text-decoration: underline !important;\n}\n\n.container-fluid {\n  a.btn-action:not([href]):not([tabindex]),\n  a.btn-action:not([href]):not([tabindex]):focus,\n  a.btn-action:not([href]):not([tabindex]):hover {\n    color: #ffffff !important;\n  }\n}\n\n.varsome-result,\n.varsome-result-fixed,\n.container-fluid {\n  a:not([href]):not([tabindex]) {\n    color: #2ca591 !important;\n  }\n\n  a:not([href]):not([tabindex]):focus,\n  a:not([href]):not([tabindex]):hover {\n    color: #1c695c;\n    text-decoration: underline;\n  }\n}\n\n.result-chooser a:not([href]):not([tabindex]):hover {\n  color: #fff !important;\n}\n\n.result-chooser a:not([href]):not([tabindex]) {\n  color: #ccc !important;\n}\n\n.result-chooser a.selected:not([href]):not([tabindex]) {\n  color: #fff !important;\n}\n\n.btn.cancel-button {\n  background-color: #e5e5e5 !important;\n}\n\n#nav-side {\n  .nav {\n    display: block !important;\n  }\n}\n\n.genome-btn-group {\n  display: inline-block !important;\n}\n\n.btn.btn-info {\n  color: #ffffff !important;\n}\n\n.popup-controls {\n  a:not([href]):not([tabindex]) {\n    color: #2ca591;\n  }\n\n  a:not([href]):not([tabindex]):hover {\n    color: #1c695c;\n  }\n\n  .btn-success {\n    color: #fff !important;\n  }\n}\n\n.radio-btns-pubs {\n  input[type=\"radio\"] {\n    opacity: 0;\n  }\n\n  input[type=\"radio\"] + label {\n    font-size: 0.9em;\n    cursor: pointer;\n    border: 1px solid #cccccc;\n    padding: 3px 10px;\n  }\n\n  input[type=\"radio\"] + label {\n    display: inline-block;\n    width: 310px;\n    cursor: pointer;\n    background-color: #ffffff;\n  }\n\n  input[type=\"radio\"]:checked + label {\n    background-color: rgba(44, 165, 145, 0.25);\n    font-weight: bold;\n  }\n}\n#fullNameToolTip {\n  max-width: 30vw !important;\n}\n.article-modal {\n  width: 90% !important;\n  max-width: 800px !important;\n}\n\n/* VP-658 SORTABLE TABLE HEADER*/\n.varsome-table-sorted {\n  th.th-sort {\n    text-align: left;\n    .sort-container {\n      padding-left: 7px;\n      padding-top: 5px;\n      .sort-dir {\n        color: gray;\n        font-size: 7px;\n        font-weight: 400px;\n        opacity: 0.5;\n      }\n      i {\n        font-size: 14px;\n        color: gray;\n        opacity: 0.5;\n      }\n      .sort-icon-container {\n        margin-top: -5px;\n      }\n    }\n  }\n  .th-sort.active .sort-container {\n    .sort-dir,\n    i {\n      color: #2ca591;\n      opacity: 1;\n    }\n  }\n  .th-sort:hover {\n    background-color: #f5f5f5;\n  }\n  .th-sort.center {\n    text-align: center;\n  }\n}\n\n/* VP-1299 START */\n\n.tag {\n  border-radius: 3px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  opacity: 0.7;\n  display: inline-block;\n  margin-right: 5px;\n  margin-top: 5px;\n  padding: 4px 7px 4px 7px;\n  cursor: default;\n  transition: opacity 0.2s linear;\n}\n\n.tooltip-text {\n  letter-spacing: 0.06em;\n  font-family: $cabin;\n}\n\n.font-cabin {\n  font-family: $cabin;\n}\n.font-raleway {\n  font-family: $raleway;\n}\n\n/* VP-1299 END */\n\n.premiumUser .varsome-inner-container {\n  .premium-badge-container {\n    margin-bottom: 5px;\n    display: inline-block;\n  }\n}\n\n.primary-link {\n  color: $primary !important;\n}\n\n.comment-content {\n  p {\n    margin: 0px;\n  }\n}\n\n.error-rectangle-box {\n  margin-top: 16px;\n  border-radius: 4px;\n  background-color: rgba(206, 49, 49, 0.15);\n}\n\n.error-box-text {\n  padding: 16px;\n  color: #ce3131;\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 24px;\n}\n\n.warning-rectangle-box {\n  margin-top: 16px;\n  border-radius: 4px;\n  background-color: rgba(223, 180, 0, 0.2);\n}\n.warning-box-text {\n  padding: 16px;\n  color: #8d7206;\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 24px;\n}\n\n.cms-modal .cms-modal {\n  &__header {\n    padding-right: 45px;\n    h1 p {\n      margin-bottom: 0;\n    }\n  }\n  &__closeBtn {\n    top: 3px;\n  }\n  &__body {\n    ul > li {\n      margin-bottom: 8px;\n    }\n  }\n  &__footer {\n    text-align: center;\n    border-top: 1px solid #d4d4d8;\n    label {\n      margin-bottom: 0px;\n      user-select: none;\n    }\n  }\n}\n\n.compact .card-info {\n  display: none;\n}\n\n.card-content {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n\n.card-item {\n  @apply tw-text-blueGray-700;\n}\n\n.cards-ui-header {\n  @apply tw-bg-blueGray-400 tw-text-white tw-font-semibold;\n}\n\n.selected-card {\n  .cards-ui-header {\n    @apply tw-bg-blueGray-500 tw-text-white;\n  }\n}\n\n.varsome_clinical {\n  .card-item.card-item-larger {\n    height: 75px;\n  }\n}\n\n.card-item {\n  height: 68px;\n  @apply tw-p-2;\n  &:hover {\n    @apply tw-text-blueGray-900;\n  }\n  * {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.compact .card-item {\n  height: unset !important;\n  @apply tw-p-0.5;\n  .icon {\n    display: none;\n  }\n  .fa {\n    display: none;\n  }\n}\n\n.compact .card-item,\n.side-container .card-item {\n  height: unset !important;\n}\n\n.top-compact .card-item {\n  min-height: 30px;\n  height: 30px !important;\n}\n\n.compact,\n.top-compact {\n  .card-item {\n    height: unset !important;\n  }\n  .cards-ui-header {\n    background-color: transparent !important;\n    @apply tw-font-normal tw-text-blueGray-900;\n  }\n}\n\n.disabled-card {\n  .cards-ui-header {\n    background-color: transparent !important;\n    color: rgb(30, 30, 60) !important;\n  }\n}\n\n.focusable-highlight-card {\n  transition: background-color 150ms linear;\n}\n\n:focus > .focusable-highlight-card {\n  @apply tw-bg-blueGray-200;\n}\n\n.selected-card {\n  opacity: 1;\n  .card-info {\n    a {\n      filter: brightness(90%);\n    }\n    @apply tw-text-blueGray-800;\n  }\n}\n\n.top-compact {\n  .card-info {\n    display: none;\n  }\n}\n\n.card-tooltip-content {\n  .hide-in-tooltip {\n    display: none;\n  }\n}\n\n.varsome-table-fixed {\n  thead tr {\n    border-top: none;\n  }\n  &--borderBody {\n    tbody td {\n      border: 1px solid #e5e5e5;\n    }\n  }\n  &--autoWidth {\n    table-layout: auto !important;\n    width: auto !important;\n  }\n}\n\n.abbr--custom {\n  cursor: help;\n  border-bottom: 1px dotted currentColor;\n}\n.varsome-table-minimum-padding {\n  td {\n    padding: 5px !important;\n  }\n}\n.gnomad-cell,\n.gnomad-cell-female {\n  background-color: whiteSmoke;\n  text-align: right;\n}\n.gnomad-cell-male {\n  background-color: whiteSmoke;\n  text-align: right;\n  border-top: 1px solid #3cdbc0;\n}\n.gnomad-cell-freq-male {\n  background-color: whiteSmoke;\n  padding-left: 95px !important;\n  border-top: 1px solid #3cdbc0;\n}\n.gnomad-cell-freq,\n.gnomad-cell-freq-female {\n  background-color: whiteSmoke;\n  padding-left: 95px !important;\n}\n",".ReactModal__Overlay {\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  z-index: 10000;\n  text-align: center;\n}\n.ReactModal__Overlay--after-open {\n  opacity: 1;\n  transition: opacity 300ms ease-out;\n}\n.ReactModal__Content--after-open {\n  transition: all 300ms ease-in;\n}\n.ReactModal__Overlay--before-close {\n  opacity: 0;\n}\n.ReactModal__Content--before-close {\n  transition: all 300ms ease-in;\n}\n\n.flag-form {\n  padding: 1rem 0 0 0;\n  overflow-y: hidden;\n  height: 90%;\n  h4 {\n    padding: 0 1.5rem;\n  }\n  .varsome-modal-content {\n    padding: 0 1.5rem 1.5rem 1.5rem;\n    height: calc(100% - 95px);\n    overflow-y: auto;\n  }\n  .varsome-modal-controls {\n    padding: 0 1.5rem 1rem 1.5rem;\n    background-color: #fafafa;\n    border-top: 1px solid #999;\n  }\n}\n\n.modal-container-window {\n  background-color: white;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  border-radius: 4px;\n}\n\n.modal--hubspot {\n  padding: 0 !important;\n  width: initial !important;\n  border-radius: 7px !important;\n  background-color: transparent !important;\n}\n\n.modal--simple {\n  padding: 2.5rem 1.5rem 2.5rem 1.5rem !important;\n  text-align: center !important;\n  width: 35rem !important;\n}\n\n.helper-text {\n  p {\n    margin-bottom: 0px !important;\n    padding-top: 4px !important;\n  }\n}\n",".tooltip-container {\n  position: fixed;\n  box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.61);\n}\n\n.tooltip-content {\n  letter-spacing: 0.025em;\n  line-height: 1.625;\n}\n\n.tooltip-default {\n  .tooltip-content {\n    @apply tw-text-blueGray-800 tw-px-2 tw-py-1 tw-max-w-96 tw-text-xs;\n    font-family: $helvetica;\n    p {\n      margin: 0px;\n      padding: 0px;\n    }\n  }\n  .tooltip-path {\n    @apply tw-text-blueGray-200 tw-stroke-current;\n    fill: white;\n  }\n}\n\n.genome-browser-tooltip {\n  .tooltip-container {\n    backdrop-filter: blur(10px);\n    box-shadow: 0px 12px 24px -10px black;\n  }\n\n  .tooltip-content {\n    @apply tw-mx-4 tw-py-2 tw-text-2xs tw-text-blueGray-600;\n  }\n\n  .tooltip-path {\n    @apply tw-stroke-current tw-text-blueGray-300;\n    fill: rgba(250, 250, 250, 0.87);\n    stroke-width: 1px;\n  }\n\n  .border-normal {\n    @apply tw-border-blueGray-400 tw-border-opacity-40;\n  }\n}\n\n.genome-browser-title {\n  .tooltip-container {\n    backdrop-filter: blur(10px);\n    box-shadow: 0px 12px 34px -10px rgba(0, 0, 7, 0.1);\n  }\n\n  .tooltip-content {\n    @apply tw-px-3 tw-py-2 tw-text-2xs tw-text-blueGray-100;\n  }\n\n  .tooltip-path {\n    @apply tw-stroke-current tw-text-blueGray-700;\n    fill: rgba(38, 48, 66, 0.75);\n    stroke-width: 1px;\n  }\n  a,\n  .link {\n    @apply tw-text-blueGray-100;\n  }\n\n  .border-normal {\n    @apply tw-border-blueGray-400 tw-border-opacity-40;\n  }\n}\n\n.genome-browser-small-tooltip {\n  .tooltip-container {\n    backdrop-filter: blur(10px);\n    box-shadow: 0px 12px 34px -10px rgba(0, 0, 7, 0.1);\n  }\n\n  .tooltip-content {\n    @apply tw-px-2 tw-py-1 tw-text-2xs tw-text-blueGray-100;\n  }\n\n  .tooltip-path {\n    @apply tw-stroke-current tw-text-blueGray-700;\n    fill: rgba(38, 48, 66, 0.75);\n    stroke-width: 1px;\n  }\n  a,\n  .link {\n    @apply tw-text-blueGray-100;\n  }\n}\n\n.publications-tooltip {\n  .tooltip-container {\n    backdrop-filter: blur(10px);\n    box-shadow: 0px 12px 24px -10px black;\n  }\n\n  .tooltip-content {\n    @apply tw-mx-4 tw-py-2 tw-text-2xs tw-text-blueGray-600;\n  }\n\n  .tooltip-path {\n    @apply tw-stroke-current tw-text-blueGray-300;\n    fill: rgba(250, 250, 250, 0.75);\n    stroke-width: 1px;\n  }\n\n  .border-normal {\n    @apply tw-border-blueGray-400 tw-border-opacity-40;\n  }\n}\n\n.tag-tooltip {\n  .tooltip-container {\n    backdrop-filter: blur(10px);\n    box-shadow: 0px 12px 24px -10px black;\n  }\n\n  .tooltip-content {\n    @apply tw-mx-4 tw-py-2 tw-text-xs tw-text-blueGray-600;\n  }\n\n  .tooltip-path {\n    @apply tw-stroke-current tw-text-blueGray-300;\n    fill: rgba(250, 250, 250, 0.87);\n    stroke-width: 1px;\n  }\n\n  .border-normal {\n    @apply tw-border-blueGray-400 tw-border-opacity-20;\n  }\n}\n\n.plot-tooltip {\n  .tooltip-content {\n    @apply tw-mx-4 tw-py-2 tw-text-xs tw-text-blueGray-700;\n  }\n\n  .tooltip-path {\n    @apply tw-stroke-current tw-text-blueGray-300;\n    fill: rgba(255, 255, 255, 1);\n    stroke-width: 1px;\n  }\n\n  .border-normal {\n    @apply tw-border-blueGray-400 tw-border-opacity-20;\n  }\n}\n\n.tooltip-header {\n  @apply tw-flex tw-items-center tw-pb-2 tw-mb-2 tw-border-b tw-text-xs;\n\n  .tooltip-title {\n    @apply tw-font-semibold tw-mr-4 tw-flex-grow;\n  }\n}\n\n.tooltip-row {\n  @apply tw-flex tw-py-0.5 tw-text-xs;\n\n  .tooltip-label {\n    @apply tw-font-semibold tw-mr-2 tw-flex-shrink-0;\n  }\n}\n",null,"$border: 0.1rem solid #e5e5e5;\n\n$bg-title: #f5f5f5;\n$primary: #2ca591;\n$primary-h: #3cdbc0;\n$success: #3cdbc0;\n$danger: #e69d9d;\n$green: #1c9868;\n$text: #373a3c;\n$text-muted: #818a91;\n\n$purple: rgb(76, 29, 149);\n$green: rgb(5, 150, 105);\n$orange: rgb(180, 83, 9);\n$red: rgb(220, 38, 38);\n$blue: rgb(30, 58, 138);\n$sky: #4b74c4;\n\n$pathogenic-very-strong: #c70700ff;\n$pathogenic-strong: #d93115ff;\n$pathogenic-moderate: #eb5b2b;\n$pathogenic-supporting: #fd8540;\n$uncertain: #ffab45ff;\n$benigh-very-strong: #076418;\n$benigh-strong: #258831;\n$benigh-moderate: #50a838;\n$benigh-supporting: #73c36f;\n$badges-label: #ffffff;\n$unknown-pathogenicity-color: #9a9ada;\n\n$table-top-border: 1px solid rgb(236, 238, 239);\n\n$raleway: \"Raleway\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$cabin: \"Cabin\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$cutive: \"Cutive Mono\", \"Menlo\", \"Monaco\", \"Consolas\", \"Courier New\";\n$helvetica: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$roboto: \"Roboto\", \"Arimo\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n","/* ADD HERE ATOMIC STYLES NOT INCLUDED IN TAILWIND */\n\n.font-awesome {\n  font-family: \"Font Awesome 5 Free\", \"FontAwesome\";\n}\n\n.grabbable {\n  cursor: move;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\n.grabbable:active {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}\n\n.text-red {\n  color: #ab230f;\n}\n\n.text-green {\n  color: #3cdbc0;\n}\n\n.font-helvetica {\n  font-family: $helvetica;\n}\n\n.font-raleway {\n  font-family: $raleway;\n}\n\n.table-p-10 {\n  td,\n  th {\n    padding: 10px;\n  }\n}\n\n.table-b-light {\n  td,\n  th {\n    border: 1px solid #eceeef;\n  }\n}\n\n.no-stroke {\n  stroke-width: 0;\n}\n\n.pseudo-class {\n  // TODO: TEMP FIX -- tALK with Andreas about it\n  @apply tw-ml-4 tw-mr-auto;\n}\n\n.backdrop {\n  background-color: rgba(180, 180, 180, 0.5);\n}\n\n.backdrop-blur {\n  backdrop-filter: blur(3px);\n}\n\n.backdrop-filter-blur {\n  backdrop-filter: blur(3px);\n}\n\n.backdrop-filter-blur-md {\n  backdrop-filter: blur(10px);\n}\n\n.shadow-inner-left {\n  // box-shadow: inset -10px -3px 15px 10px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 7px 0px 15px -8px rgba(0, 0, 0, 0.1);\n}\n\n.max-h-screen-50px {\n  max-height: calc(100vh - 50px);\n}\n\n.left--px {\n  left: -1px;\n}\n\n.no-border-last:last-child {\n  border-color: transparent !important;\n}\n\n.show-parent-hover {\n  opacity: 0;\n  visibility: hidden;\n}\n\n*:hover > .show-parent-hover,\n*:focus-within > .show-parent-hover {\n  visibility: visible;\n  opacity: 1 !important;\n  transition: opacity 300ms linear;\n}\n\n.show-parent-focus {\n  opacity: 0;\n  visibility: hidden;\n}\n\n*:focus-within > .show-parent-focus {\n  visibility: visible;\n  opacity: 1 !important;\n  transition: opacity 400ms linear;\n}\n\n.transform-translate-x-100 {\n  transform: translateX(100%);\n}\n\n.transform-translate--y-50 {\n  transform: translateY(-50%);\n}\n\n.transition-linear {\n  transition-timing-function: linear;\n}\n\n.transition-top {\n  transition: top 0.2s linear;\n}\n\n.flex-basis-0 {\n  flex: 1 1 0px;\n}\n\n.font-roboto {\n  font-family: \"Roboto\", sans-serif;\n}\n\n.only-on-premium {\n  display: none;\n}\n\n.premiumUser {\n  .only-on-premium {\n    display: block;\n  }\n}\n\n.premiumUser {\n  .only-not-premium {\n    display: none;\n  }\n}\n\n.no-margin {\n  margin: 0px !important;\n}\n\n.prevent-scroll {\n  overflow: hidden;\n}\n\n.text-larger-1 {\n  font-size: 1.1em;\n  line-height: 1.1em;\n}\n\n.text-larger-2 {\n  font-size: 1.15em;\n  line-height: 1.15em;\n}\n\n.text-larger-3 {\n  font-size: 1.2em;\n  line-height: 1.2em;\n}\n\n.text-larger-4 {\n  font-size: 1.3em;\n  line-height: 1.3em;\n}\n\n.text-smaller-1 {\n  font-size: 0.9em;\n  line-height: 0.9em;\n}\n\n.text-smaller-2 {\n  font-size: 0.8em;\n  line-height: 0.8em;\n}\n.text-smaller-3 {\n  font-size: 0.7em;\n  line-height: 0.7em;\n}\n","@-webkit-keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n@-webkit-keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n@-moz-keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n@-ms-keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n@-moz-keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n@-webkit-keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n@-o-keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n@keyframes uil-ripple {\n    0% {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        margin: 0 0 0 0;\n    }\n    33% {\n        width: 44%;\n        height: 44%;\n        margin: -22% 0 0 -22%;\n        opacity: 1;\n    }\n    100% {\n        width: 88%;\n        height: 88%;\n        margin: -44% 0 0 -44%;\n        opacity: 0;\n    }\n}\n.varsome-loader {\n    background: none;\n    width: 200px;\n    height: 200px;\n    margin: 0 auto;\n    &.small-loader {\n        width: 100px;\n        height: 100px;\n    }\n}\n.varsome-loader div {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: 0;\n    width: 0;\n    height: 0;\n    opacity: 0;\n    border-radius: 50%;\n    border-width: 16px;\n    border-style: solid;\n    -ms-animation: uil-ripple 2s ease-out infinite;\n    -moz-animation: uil-ripple 2s ease-out infinite;\n    -webkit-animation: uil-ripple 2s ease-out infinite;\n    -o-animation: uil-ripple 2s ease-out infinite;\n    animation: uil-ripple 2s ease-out infinite;\n}\n.small-loader div {\n    border-width: 8px;\n}\n.varsome-loader div:nth-of-type(1) {\n    border-color: #555555;\n}\n.varsome-loader div:nth-of-type(2) {\n    border-color: $success;\n    -ms-animation-delay: 1s;\n    -moz-animation-delay: 1s;\n    -webkit-animation-delay: 1s;\n    -o-animation-delay: 1s;\n    animation-delay: 1s;\n}","@font-face {\n    font-family: 'varsome-icons';\n    src:\n        url('fonts/varsome-icons.ttf?qo1493') format('truetype'),\n        url('fonts/varsome-icons.woff?qo1493') format('woff'),\n        url('fonts/varsome-icons.svg?qo1493#varsome-icons') format('svg');\n    font-weight: normal;\n    font-style: normal;\n}\n\ni.varsome-icons{\n    /* use !important to prevent issues with browser extensions that change fonts */\n    font-family: 'varsome-icons' !important;\n    speak: none;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-fullscreen:before{\n    content: \"\\e900\";\n}\n.icon-star:before{\n    content: \"\\f005\";\n}\n.icon-star-o:before{\n    content: \"\\f006\";\n}\n.icon-chevron-right:before{\n    content: \"\\e901\";\n}\n.icon-chevron-left:before{\n    content: \"\\e902\";\n}\n.icon-chevron-down:before{\n    content: \"\\e903\";\n}\n.icon-chevron-up:before{\n    content: \"\\e904\";\n}\n.icon-search-minus:before{\n    content: \"\\e905\";\n}\n.icon-search-plus:before{\n    content: \"\\e906\";\n}\n.icon-close:before{\n    content: \"\\e907\";\n}\n.icon-question:before{\n    content: \"\\ea09\";\n}\n.icon-info:before{\n    content: \"\\ea0c\";\n}\n.icon-cancel-circle:before{\n    content: \"\\ea0d\";\n}\n.icon-indent-increase:before{\n    content: \"\\ea7b\";\n}\n.icon-indent-decrease:before{\n    content: \"\\ea7c\";\n}\n.icon-arrow-right2:before {\n  content: \"\\ea3c\";\n}\n.icon-arrow-left2:before {\n  content: \"\\ea40\";\n}\n.iconcaret-down:before {\n  content: \"\\f0d7\";\n}\n.iconcaret-up:before {\n  content: \"\\f0d8\";\n}\n.iconcaret-left:before {\n  content: \"\\f0d9\";\n}\n.iconcaret-right:before {\n  content: \"\\f0da\";\n}\n","@import \"variables\";\n\n@mixin acmgColorsMixin($color) {\n  background-color: $color;\n  color: $badges-label;\n\n  .rule-name:hover {\n    background-color: lighten($color, 10);\n  }\n\n  .acmg-strength-dropdown:hover {\n    cursor: pointer;\n    background-color: lighten($color, 10);\n  }\n}\n\n.varsome-acmg-verdict {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.varsome-acmg-grid {\n  tr {\n    border-top: 1px solid #ccc !important;\n    border-bottom: 1px solid #ccc !important;\n  }\n  td {\n    text-align: center;\n    cursor: pointer;\n    border-left: 1px solid #ccc;\n    border-right: 1px solid #ccc;\n    .rule-name {\n      padding: 0.5rem;\n      &:hover {\n        background-color: #eaeaea;\n      }\n    }\n    .rule-icon {\n      cursor: pointer;\n      padding: 0.5rem;\n      i {\n        color: rgba(60, 180, 255, 1);\n      }\n    }\n  }\n}\n\n.acmg-rules-table {\n  padding-top: 0.6rem !important;\n  padding-bottom: 0.1rem !important;\n  padding-left: 1px !important;\n  padding-right: 1px !important;\n}\n\n@media (max-width: 1199px) {\n  .Dropdown-root {\n    position: relative;\n    margin-top: 2px;\n  }\n  .Dropdown-control {\n    position: relative;\n    overflow: hidden;\n    background-color: white;\n    border-radius: 2px;\n    box-sizing: border-box;\n    color: #333;\n    cursor: default;\n    outline: none;\n    padding: 2px 0px 2px 0px;\n    transition: all 200ms ease;\n  }\n  .Dropdown-arrow {\n    border-color: #999 transparent transparent;\n    border-style: solid;\n    border-width: 5px 5px 0;\n    content: \" \";\n    display: inline-block;\n    height: 0;\n    margin-top: -ceil(2.5);\n    width: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .Dropdown-root {\n    position: relative;\n    margin-top: 2px;\n    display: inline-block;\n    width: 90%;\n  }\n  .Dropdown-control {\n    position: relative;\n    overflow: hidden;\n    background-color: white;\n    border-radius: 2px;\n    box-sizing: border-box;\n    color: #333;\n    cursor: default;\n    outline: none;\n    padding: 2px 25px 2px 3px;\n    transition: all 200ms ease;\n  }\n  .Dropdown-arrow {\n    border-color: #999 transparent transparent;\n    border-style: solid;\n    border-width: 5px 5px 0;\n    content: \" \";\n    display: block;\n    height: 0;\n    margin-top: -ceil(2.5);\n    position: absolute;\n    right: 16px;\n    top: 8px;\n    width: 0;\n  }\n}\n.Dropdown-control:hover {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n\n.is-open .Dropdown-arrow {\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n\n.Dropdown-arrow-color {\n  //border-color: #999 transparent transparent;\n  border-color: #ffffff transparent transparent !important;\n}\n\n.Dropdown-arrow-color-disabled {\n  border-color: #dcdcdc transparent transparent !important;\n}\n\n.Dropdown-menu {\n  border: 1px solid #ffffff;\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 90;\n  -webkit-overflow-scrolling: touch;\n}\n\n.Dropdown-menu .Dropdown-group > .Dropdown-title {\n  padding: 8px 10px;\n  color: rgba(51, 51, 51, 1);\n  font-weight: bold;\n  text-transform: capitalize;\n}\n\n.Dropdown-option {\n  box-sizing: border-box;\n  color: rgba(51, 51, 51, 0.8);\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n}\n\n.Dropdown-option:hover {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.Dropdown-option.is-selected {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.Dropdown-noresults {\n  box-sizing: border-box;\n  color: #ccc;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n\n.Dropdown-placeholder-color-default-strength {\n  font-size: 1rem;\n  color: #ffffff !important;\n}\n\n.Dropdown-placeholder-color-custom-strength {\n  font-size: 1rem;\n  color: #ffffff !important;\n}\n\n.Dropdown-placeholder-color-rule-disabled {\n  font-size: 1rem;\n  color: #dcdcdc !important;\n}\n\n.Dropdown-backgroundColor {\n  background-color: transparent !important;\n}\n\n.Dropdown-menu-color {\n  background-color: #ffffff !important;\n}\n\n.varsome-acmg-grid * {\n  line-height: 1 !important;\n}\n\n.varsome-criteria-table {\n  .badge {\n    font-weight: normal;\n    padding: 0.7em 0.7em;\n    border-radius: 25px;\n    width: 100%;\n    font-size: 100%;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n\n.stand-alone-color,\n.very-strong-color,\n.strong-color {\n  color: #ffffff !important;\n}\n.moderate-color,\n.supporting-color {\n  color: #ffffff !important;\n}\n.acmg-rule-colored-cell {\n  padding-left: 8px;\n  padding-right: 8px;\n  &.rule-name-p {\n    &.rule-strength-stand-alone {\n      @include acmgColorsMixin($pathogenic-very-strong);\n    }\n    &.rule-strength-very-strong {\n      @include acmgColorsMixin($pathogenic-very-strong);\n    }\n    &.rule-strength-strong {\n      @include acmgColorsMixin($pathogenic-strong);\n    }\n    &.rule-strength-moderate {\n      @include acmgColorsMixin($pathogenic-moderate);\n    }\n    &.rule-strength-supporting {\n      @include acmgColorsMixin($pathogenic-supporting);\n    }\n  }\n  &.rule-name-b {\n    &.rule-strength-stand-alone {\n      @include acmgColorsMixin($benigh-very-strong);\n    }\n    &.rule-strength-very-strong {\n      @include acmgColorsMixin($benigh-very-strong);\n    }\n    &.rule-strength-strong {\n      @include acmgColorsMixin($benigh-strong);\n    }\n    &.rule-strength-moderate {\n      @include acmgColorsMixin($benigh-moderate);\n    }\n    &.rule-strength-supporting {\n      @include acmgColorsMixin($benigh-supporting);\n    }\n  }\n  &.rule-manually-disabled {\n    background-color: #bbb;\n  }\n}\n",".varsome-axis-label{\n    color: $text;\n}\n\n.varsome-rpkm-bar{\n    fill: #577396;\n    &:hover{\n        fill: #6989af;\n    }\n    &--highlight{\n        fill: #ff6f23;\n        &:hover{\n            fill: #fc8140;\n        }\n    }\n}\n\n.varsome-het-bar{\n    fill: #53a292;\n    &:hover{\n        opacity: 0.5;\n    }\n}\n\n.varsome-hom-bar{\n    fill: #7ac5b2;\n    &:hover{\n        opacity: 0.8;\n    }\n}\n\n.varsome-atlas-bar{\n    fill: #2ca591;\n    &:hover{\n        opacity: 0.8;\n    }\n}","html {\n  -ms-overflow-style: scrollbar;\n  font-size: 14px;\n  -webkit-tap-highlight-color: transparent;\n}\n\nbody {\n  font-family: \"Cabin\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #373a3c;\n  background-color: #fff;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  margin: 0;\n  line-height: inherit;\n  font: inherit;\n  color: inherit;\n}\n\n.gdpr-btn {\n  display: inline-block;\n  margin: 0 0.3em 0.3em 0;\n  padding: 0.3em 0.3em;\n  font-weight: 600;\n  font-size: 1em;\n  color: #007a86;\n  border: 1px solid #ddd;\n  border-radius: 0.2em;\n}\n\nbutton.gdpr-link {\n  color: #818a91;\n  text-align: center;\n  background: none;\n  border: none;\n  padding: 0 !important;\n  font: inherit;\n  cursor: pointer;\n  width: 100%;\n  &:hover {\n    text-decoration: underline;\n  }\n  &:focus {\n    outline: none;\n  }\n}\n\n.gdpr-btn:focus {\n  outline: none;\n}\n\n.gdpr-modal:focus {\n  outline: none;\n}\n\n.gdpr-error-modal {\n  font-family: Cabin, \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  background-color: #fafafa;\n  height: auto !important;\n}\n.gdpr-request-error {\n  width: 100%;\n  margin: 10% 0;\n  padding: 1rem 0.5rem;\n  background-color: #e69d9d;\n  color: #fff;\n  white-space: pre-line;\n  text-align: center;\n}\n\n.gdpr-modal {\n  // width: 45vw;\n  // text-align: left;\n  font-size: 1.125rem;\n  font-family: Cabin, \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  /*  Device = Tablets, Ipads (landscape)\n        Screen = B/w 768px to 1024px\n    */\n  @media all and (min-width: 768px) and (max-width: 1200px) {\n    font-size: 1rem;\n  }\n\n  @media all and (max-width: 767px) {\n    font-size: 0.85em;\n  }\n\n  a:not([href]):not([tabindex]),\n  a:not([href]):not([tabindex]):focus,\n  a:not([href]):not([tabindex]):hover {\n    color: #2ca591 !important;\n    text-decoration: none !important;\n  }\n\n  a:not([href]):hover {\n    color: #1c695c !important;\n    text-decoration: underline !important;\n  }\n\n  /*----- VarSome logo -----*/\n\n  .varsome-logo {\n    max-width: 25%;\n  }\n\n  @media all and (min-width: 768px) and (max-width: 1024px) {\n    .varsome-logo {\n      max-width: 30%;\n    }\n  }\n\n  @media all and (max-width: 767px) {\n    .varsome-logo {\n      max-width: 40%;\n    }\n  }\n\n  @media all and (min-width: 768px) and (max-width: 1024px) {\n    .terms-checkbox {\n      margin-left: 2em;\n    }\n  }\n\n  @media all and (max-width: 767px) {\n    .terms-checkbox {\n      margin-left: 2em;\n    }\n  }\n\n  input[type=\"checkbox\"] {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    vertical-align: middle;\n    width: 15px;\n    height: 15px;\n    font-size: 20px;\n    border: 1px solid #000000;\n  }\n\n  input[type=\"checkbox\"]:checked:after {\n    position: relative;\n    bottom: 8px;\n    left: -1px;\n    content: \"\\2713\"; /* check mark */\n  }\n\n  input[type=\"checkbox\"] ~ label {\n    margin-top: -4px;\n    margin-left: 25px;\n    display: inline-block;\n  }\n\n  input:focus {\n    outline: none;\n  }\n\n  /*----- Action buttons -----*/\n\n  button:focus {\n    outline: none;\n  }\n\n  .action-btns {\n    display: inline-block;\n    width: 25%;\n    margin: 0 0.3em 0.3em 0;\n    padding: 0.3em 0.3em;\n    font-weight: 600;\n    font-size: 1em;\n    color: #ffffff;\n    border: 0.16em solid rgba(255, 255, 255, 0);\n  }\n\n  .btn-accept-submit {\n    background-color: #217d6e;\n    border-color: #217d6e;\n    &:hover {\n      border-color: #ffffff;\n      border-radius: 0.2em;\n    }\n  }\n\n  .btn-submit:disabled,\n  .btn-submit[disabled] {\n    border: 1px solid #999999;\n    background-color: #fafafa;\n    color: #999999;\n    &:hover {\n      pointer-events: none;\n    }\n  }\n\n  .btn-submit:enabled,\n  .btn-submit[enabled] {\n    color: #fff;\n    border-color: #217d6e;\n    background-color: #217d6e;\n    &:hover {\n      border-color: #ffffff;\n      border-radius: 0.2em;\n    }\n  }\n\n  .flex-box-2 {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  @media all and (max-width: 767px) {\n    .action-btns {\n      display: block;\n      margin-left: 0.2em auto;\n      width: 100%;\n      font-size: 0.8em;\n    }\n  }\n\n  .error-box {\n    color: #ffffff;\n    text-align: center;\n    margin-top: 1rem;\n    background-color: #e69d9d;\n    padding: 1rem 0.5rem;\n  }\n\n  @media all and (max-width: 767px) {\n    .error-box {\n      margin-top: 4em;\n    }\n  }\n}\n","\ntext.color-legend {\n    font-family: $raleway;\n    font-size: 10px;\n}\n\ntext.exp-map-xlabel {\n    font-family: $raleway;\n    font-size: 10px;\n}\n\ntext.exp-map-xlabel.highlighted {\n    font-weight: 400;\n    font-size: 12px;\n    text-decoration: underline;\n}\n\ntext.exp-map-xlabel.query {\n    font-weight: 600;\n    font-size:11px;\n    fill: #d2111b;\n}\n\ntext.exp-map-ylabel {\n    font-family: $raleway;\n    font-size: 10px;\n}\n\ntext.exp-map-ylabel.highlighted {\n    font-weight: 400;\n    font-size: 12px;\n    text-decoration: underline;\n}\n\ntext.exp-map-ylabel.clicked, text.exp-map-xlabel.clicked {\n    fill: #D25C43;\n}\n\nrect.exp-map-cell {\n    stroke-width:0px;\n}\n\nrect.exp-map-cell.highlighted {\n    stroke: #D25C43;\n    stroke-width:2px;\n}\n\ndiv.heatmap-tooltip {\n    min-width: 100px;\n    display: none;\n    background-color : rgba(32, 53, 73, 0.95);\n    padding: 10px;\n    text-align:left;\n    color: #ffffff;\n    position:absolute;\n    font-size:12px;\n    z-index:4000;\n    border-radius:5px;\n}\n\n\n\n",".charts-container{\n  display:flex;\n  flex-wrap: wrap;\n}\n\n.chart {\n  flex: 0 0 100%;\n  border: 1px solid #dddddd;\n  padding: 5px;\n  border-radius: 4px;\n  margin: 0px 0 5px;\n  position: relative;\n  overflow: hidden;\n  .chart {\n    width:100%;\n    height:100%;\n    margin: 0 !important;\n    padding: 0;\n    flex: 1;\n    border: none;\n    .custom-container{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n    }\n  }\n  @media (min-width: 1024px) {\n    flex: 0 0 calc(50% - 5px);\n    &:nth-of-type(odd) {\n      margin-right: 5px;\n    }\n  }\n  @media (min-width: 1367px) {\n    padding: 10px;\n    margin: 0px 0 10px;\n    flex: 0 0 calc(33% - 4px);\n    &:nth-of-type(odd) {\n      margin-right: 0;\n    }\n    &:nth-of-type(3n + 2) {\n      margin-left: 10px;\n      margin-right: 10px;\n    }\n  }\n\n  canvas {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n  &--vertical {\n    width: 100%;\n    height: auto;\n  }\n  &--empty{\n    & *{\n      color:#577396;\n    }\n    width: 200px;\n    height: 160px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    background-color: #f7f7f7;\n    padding: 0 20px;\n    text-align: center;\n    margin: 0 auto;\n    i{\n      font-size: 1.8rem;\n      display: flex;\n      justify-content: center;\n      color:#577396;\n      \n    }\n    p{\n      padding: 1rem 0 0 0;\n      color:#577396;\n    }\n    .emphasize{\n      font-weight:600;\n      color:#4e6075;\n    }\n  }\n  &--premium{\n    & *{\n      color:#2ca591;\n    }\n    width: 200px;\n    height: 160px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    background-color: #f7f7f7;\n    padding: 0 20px;\n    text-align: center;\n    margin: 0 auto;\n    i{\n      font-size: 1.8rem;\n      display: flex;\n      justify-content: center;\n      color:#2ca591;\n      \n    }\n    p{\n      padding: 1rem 0 0 0;\n      color:#000000;\n    }\n    .emphasize{\n      font-weight:600;\n      color:#000000;\n    }\n  }\n}\n.hidden {\n  display: none !important;\n}",".prisma_tables {\n  .table-container {\n    overflow-y: auto;\n  }\n}\n\n.varsome_table {\n  border-collapse: collapse;\n  min-width: 300px;\n  width: initial;\n  margin-bottom: 0;\n  table {\n    width: 100%;\n  }\n  tr {\n    width: 100%;\n  }\n  th,\n  td {\n    box-sizing: border-box;\n    padding: 10px;\n    font-size: 12px;\n  }\n  td {\n    border: 1px solid #eceeef;\n  }\n  thead {\n    th {\n      background: #f5f5f5;\n      color: #373a3c;\n      text-align: center;\n      line-height: 1.5em;\n      border-bottom: 1px solid #3cdbc0;\n      font-weight: 400;\n    }\n  }\n  tbody {\n    text-align: left;\n    td {\n      font-weight: bold;\n      &.font-normal{\n        font-weight:normal;\n      }\n    }\n  }\n  .numeric {\n    text-align: right;\n    width: 1%;\n    white-space: nowrap;\n  }\n  .center{\n    text-align: center;\n  }\n  .left{\n    text-align: left;\n  }\n  &.full-width{\n    width:100%;\n  }\n  tr{\n    &.highlight td{\n      background-color: #dde3ea;\n    }\n  }\n  &--reset-bold-td{\n    td{\n      font-weight:normal !important;\n    }\n  }\n  &--stripped-hover{\n    tr:hover{\n      td{\n        background-color:white;\n      }\n    }\n  }\n  &--roboto{\n    font-family:\"Roboto\", sans-serif;\n  }\n  &--td-th-no-wrap{\n    td,th{\n      white-space: nowrap;\n    }\n  }\n}\n\n.sources_table{\n  table{\n    position:relative;\n  }\n  td{\n    background-color:#f1f0f0;\n  }\n  tr.negative td{\n    background-color:#FFF;\n  }\n  .fit{\n    width: 1%;\n    white-space: nowrap;\n  }\n  th {\n    position: sticky;\n    top: 100px;\n    z-index: 2;\n    background-color:#d7e1eb !important;\n  }\n}\n",".saph-green-btn {\n  @apply tw-inline-block\n    tw-mr-2\n    tw-rounded-none\n    tw-cursor-pointer\n    tw-px-6\n    tw-py-2\n    tw-font-medium\n    tw-text-sm\n    tw-no-underline\n    tw-duration-300\n    tw-transition-all\n    tw-border\n    tw-border-primary\n    tw-bg-primary\n    tw-text-white;\n}\n\n.saph-green-btn:hover {\n  @apply tw-bg-primaryLighter\n  tw-border-primaryLighter;\n}\n\n.saph-white-ghost {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-2\n  tw-mb-1\n  tw-rounded-sm\n  tw-duration-300\n  tw-transition-all\n  tw-border\n  tw-text-white\n  tw-border-blueGray-100\n  tw-px-1\n  tw-py-0.5;\n}\n\n.saph-green-ghost {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-2\n  tw-rounded-sm\n  tw-duration-300\n  tw-transition-all\n  tw-text-sm\n  tw-p-2\n  tw-border\n  tw-text-primary\n  tw-border-primary;\n}\n\n.saph-green-ghost--small {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-1\n  tw-mb-1\n  tw-rounded-sm\n  tw-duration-300\n  tw-transition-all\n  tw-text-sm\n  tw-px-1\n  tw-border\n  tw-text-primary\n  tw-border-primary;\n}\n\n.saph-green-ghost--small.active {\n  @apply tw-text-white\n  tw-bg-primary;\n}\n\n.saph-combo-button {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-2\n  tw-text-white\n  tw-rounded-sm\n  tw-text-sm\n  tw-p-0\n  tw-border\n  tw-border-warmGray-100;\n}\n\n.saph-combo-button > .saph-button {\n  @apply tw-mr-0\n  tw-border-none\n  tw-rounded-none;\n}\n\n.btn.disabled,\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.45 !important;\n}\n","$md-radio-checked-color: #2ca591;\n$md-radio-border-color: rgba(150, 150, 160, 1);\n$md-radio-size: 20px;\n$md-radio-checked-size: 10px;\n$md-radio-ripple-size: 15px;\n\n.radiobuttons {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  .radiobutton {\n    margin: 0 0 16px 0;\n    &:last-of-type {\n      .label{\n        padding-right: 0;\n      }\n    }\n    input[type=\"radio\"] {\n      display: none;\n      &:checked + label:before {\n        border-color: $md-radio-checked-color;\n        animation: ripple 0.2s linear forwards;\n      }\n\n      &:checked + label:after {\n        transform: scale(1);\n      }\n      &:disabled {\n        & + label {\n          color: rgba(0, 0, 0, 0.42);\n          cursor: not-allowed;\n          user-select: none;\n        }\n        & + label:before {\n          border-color: rgba(0, 0, 0, 0.24);\n        }\n      }\n    }\n\n    label {\n      display: inline-block;\n      height: $md-radio-size;\n      position: relative;\n      padding: 0 ($md-radio-size + 10px);\n      margin-bottom: 0;\n      cursor: pointer;\n      vertical-align: bottom;\n      \n      &:before,\n      &:after {\n        position: absolute;\n        content: \"\";\n        border-radius: 50%;\n        transition: all 0.3s ease;\n        transition-property: transform, border-color;\n      }\n\n      &:before {\n        left: 0;\n        top: 0;\n        width: $md-radio-size;\n        height: $md-radio-size;\n        border: 2px solid $md-radio-border-color;\n      }\n\n      &:after {\n        top: calc(#{$md-radio-size} / 2 - #{$md-radio-checked-size} / 2);\n        left: calc(#{$md-radio-size} / 2 - #{$md-radio-checked-size} / 2);\n        width: $md-radio-checked-size;\n        height: $md-radio-checked-size;\n        transform: scale(0);\n        background: $md-radio-checked-color;\n      }\n    }\n\n    .info-text {\n      font-size: 10px;\n      margin: 2px 0 0 0;\n      font-style: italic;\n      line-height: 1em;\n      user-select: none;\n    }\n  }\n  &--inline {\n    display: inline-flex;\n    flex-wrap: wrap;\n    margin-right: 16px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n  &--small {\n    .radiobutton {\n      margin-bottom: 0px;\n      label {\n        height: 14px;\n        padding: 0px 10px 0px 16px;\n        &:before {\n          width: 14px;\n          height: 14px;\n          border: 1px solid $md-radio-border-color;\n        }\n        &:after {\n          top: 3px;\n          left: 3px;\n          width: 8px;\n          height: 8px;\n        }\n      }\n    }\n  }\n}\n\n@keyframes ripple {\n  0% {\n    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0);\n  }\n\n  50% {\n    box-shadow: 0px 0px 0px $md-radio-ripple-size rgba(0, 0, 0, 0.1);\n  }\n\n  100% {\n    box-shadow: 0px 0px 0px $md-radio-ripple-size rgba(0, 0, 0, 0);\n  }\n}\n",".icon-xxs{\n  width:14px;\n  height:14px;\n  display:inline-block;\n}",".noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n     -khtml-user-select: none; /* Konqueror HTML */\n       -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n            user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}",".saph-pill{\n  min-width:200px;\n  @apply\n  tw-text-white \n  tw-font-semibold \n  tw-rounded-3xl \n  tw-text-base \n  tw-py-1 \n  tw-px-3 \n  tw-text-center\n}\n\n.saph-pill.saph-pill-amp{\n  min-width:150px;\n}",".legend{\n    &__header{\n        .desc{\n            font-size:11px;\n            font-style: italic;\n            margin-left:4px;\n        }\n    }\n    .varsome_table{\n        min-width:initial;\n        margin-bottom:1.25rem;\n        .numeric{\n            font-weight:400;\n            font-family: $cabin;\n        }\n    }\n    .checkbox{\n        label{\n            margin-bottom:0;\n        }\n    }\n}",".pub-expanded {\n  .abstract-text {\n    .pub-text-label {\n      margin-top: 1.5em;\n      font-size: 0.8em;\n      font-weight: bold;\n    }\n  }\n\n  .abstract-text:first-child {\n    .pub-text-label {\n      margin-top: 0px;\n    }\n  }\n\n  .pub-text-label {\n    line-height: 1em;\n    font-size: 0.8em;\n    font-weight: bold;\n  }\n\n  .copyright-text {\n    font-size: 0.9em;\n    margin-top: 1em;\n  }\n}\n.pub-collapsed {\n  .abstract-text {\n    .pub-text-label {\n      @apply tw-mr-2 tw-inline-block;\n    }\n  }\n\n  .pub-text-label {\n    line-height: 1em;\n    font-size: 1em;\n    font-weight: normal;\n  }\n}\n\n.pub-collapsed {\n  .abstract-cuttof-t {\n    @apply tw-bg-gradient-to-t tw-from-transparent tw-to-white tw-h-1;\n  }\n\n  .abstract-cuttof-b {\n    @apply tw-bg-gradient-to-b  tw-from-transparent tw-to-white tw-h-1;\n  }\n\n  .tags-cuttof {\n    @apply tw-bg-gradient-to-r tw-to-white tw-from-transparent tw-h-4;\n  }\n}\n\n.pub-collapsed:hover .abstract-cuttof {\n  @apply tw-bg-gradient-to-b tw-to-white tw-from-transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
